window.onerror = function(msg, url, line) {
  try {
    if (!document.body) return;
    var d = document.createElement('div');
    d.style.cssText = 'position:fixed;top:0;left:0;right:0;padding:15px;background:#c00;color:#fff;font:14px monospace;z-index:99999;';
    d.textContent = 'JS Error line ' + line + ': ' + msg;
    document.body.appendChild(d);
  } catch(e) { /* swallow */ }
};

document.addEventListener('DOMContentLoaded', function() {

/* ╔════════════════════════════════════════════════════════════════╗
   ║  CONSTANTS & CONFIG                                          ║
   ╚════════════════════════════════════════════════════════════════╝ */

const CS = 100; // ClipperLib scale
const IN_TO_MM = 25.4;

const ROAD_WIDTHS = { motorway:0.85, trunk:0.7, primary:0.55, secondary:0.42, tertiary:0.32, minor:0.22, service:0.15, track:0.12, path:0.1 };

/* ╔════════════════════════════════════════════════════════════════╗
   ║  STATE                                                       ║
   ╚════════════════════════════════════════════════════════════════╝ */

const S = {
  map: null,
  zoom: 14,
  detail: 'high',
  roadsVisible: true,
  width: 9,
  height: 9,
  unit: 'in',
  mainRoadWidth: 1.0,
  sideRoadWidth: 1.0,
  roadThickIdx: 2, // 0=Thinnest..4=Thickest
  labelsVisible: true,
  labelSzPx: 14, // font size in px
  gpxCoords: null,
  gpxRouteWidth: 0.6,
  depthLayers: 1,
  compassCorner: 'tl',
  compassSize: 1.0,
  compassMerge: false,
  frameThickness: 0.02,
  titleText: '',
  titleFont: "'Great Vibes',cursive",
  titleSzMult: 1.0,
  titleDx: 0,
  titleDy: 0,
  cov2: 50,
  cov3: 25,
  cov4: 12,
  contourLines: true,
  contourDensity: 2, // 0=Fewest,1=Fewer,2=Normal,3=More,4=Most
};

/* ── Detail scaling: larger plaques get relatively finer features ── */
function getDetailScale() {  // Reference plaque diagonal: 7x9 inches = ~178x229mm, diagonal ~289mm
  var wMm = getWidthMm(), hMm = getHeightMm();
  var diag = Math.sqrt(wMm*wMm + hMm*hMm);
  var refDiag = 289;
  // Scale below 1 for larger plaques (more detail), above 1 for smaller (less detail)
  // Sub-linear: sqrt gives gentle transition
  return Math.pow(refDiag / diag, 0.5);
}

/* ── Chain marching-squares segments into continuous polylines ── */
function chainSegments(segs) {
  if (!segs || !segs.length) return [];
  var EPS = 0.01;
  var key = function(p){ return Math.round(p[0]*100) + ',' + Math.round(p[1]*100); };
  var used = new Uint8Array(segs.length);
  var startMap = {};
  for (var i = 0; i < segs.length; i++) {
    var s = segs[i];
    var k0 = key(s[0]), k1 = key(s[1]);
    if (!startMap[k0]) startMap[k0] = [];
    if (!startMap[k1]) startMap[k1] = [];
    startMap[k0].push({idx: i, endpoint: 0});
    startMap[k1].push({idx: i, endpoint: 1});
  }
  var chains = [];
  for (var si = 0; si < segs.length; si++) {
    if (used[si]) continue;
    used[si] = 1;
    var chain = [segs[si][0], segs[si][1]];
    // Extend forward
    var lastKey = key(chain[chain.length - 1]);
    while (true) {
      var candidates = startMap[lastKey] || [];
      var next = -1;
      for (var ci = 0; ci < candidates.length; ci++) {
        var cand = candidates[ci];
        if (!used[cand.idx]) { next = cand; break; }
      }
      if (next === -1) break;
      used[next.idx] = 1;
      var otherPt = segs[next.idx][1 - next.endpoint];
      chain.push(otherPt);
      lastKey = key(otherPt);
    }
    // Extend backward
    var firstKey = key(chain[0]);
    while (true) {
      var candidates2 = startMap[firstKey] || [];
      var prev = -1;
      for (var ci2 = 0; ci2 < candidates2.length; ci2++) {
        var cand2 = candidates2[ci2];
        if (!used[cand2.idx]) { prev = cand2; break; }
      }
      if (prev === -1) break;
      used[prev.idx] = 1;
      var otherPt2 = segs[prev.idx][1 - prev.endpoint];
      chain.unshift(otherPt2);
      firstKey = key(otherPt2);
    }
    if (chain.length >= 2) chains.push(chain);
  }
  return chains;
}

/* ── Chaikin smoothing: subdivide corners into curves ── */
function chaikinSmooth(pts, iterations) {
  if (!pts || pts.length < 3) return pts;
  var current = pts;
  var isClosed = Math.abs(current[0][0] - current[current.length-1][0]) < 0.02 &&
                 Math.abs(current[0][1] - current[current.length-1][1]) < 0.02;
  for (var it = 0; it < iterations; it++) {
    var next = [];
    if (!isClosed) next.push(current[0]);
    for (var i = 0; i < current.length - 1; i++) {
      var p1 = current[i], p2 = current[i+1];
      next.push([p1[0]*0.75 + p2[0]*0.25, p1[1]*0.75 + p2[1]*0.25]);
      next.push([p1[0]*0.25 + p2[0]*0.75, p1[1]*0.25 + p2[1]*0.75]);
    }
    if (!isClosed) next.push(current[current.length-1]);
    else next.push(next[0]);
    current = next;
  }
  return current;
}

var WATER_COLOR = '#006585';
var DEPTH_COLORS = ['#cfc5a6','#73896d','#9dac99','#b9c4b6'];

/* ── Font TTF URL map for opentype.js path conversion ── */
var FONT_TTF_URLS = {
  "'Great Vibes',cursive": 'https://cdn.jsdelivr.net/fontsource/fonts/great-vibes@latest/latin-400-normal.ttf',
  "'Dancing Script',cursive": 'https://cdn.jsdelivr.net/fontsource/fonts/dancing-script@latest/latin-700-normal.ttf',
  "'Alex Brush',cursive": 'https://cdn.jsdelivr.net/fontsource/fonts/alex-brush@latest/latin-400-normal.ttf',
  "Cinzel,serif": 'https://cdn.jsdelivr.net/fontsource/fonts/cinzel@latest/latin-700-normal.ttf',
  "'Cormorant Garamond',serif": 'https://cdn.jsdelivr.net/fontsource/fonts/cormorant-garamond@latest/latin-700-normal.ttf',
  "Parisienne,cursive": 'https://cdn.jsdelivr.net/fontsource/fonts/parisienne@latest/latin-400-normal.ttf',
  "'Pinyon Script',cursive": 'https://cdn.jsdelivr.net/fontsource/fonts/pinyon-script@latest/latin-400-normal.ttf',
  "Sacramento,cursive": 'https://cdn.jsdelivr.net/fontsource/fonts/sacramento@latest/latin-400-normal.ttf'
};
var LABEL_FONT_URL = 'https://cdn.jsdelivr.net/fontsource/fonts/inter@latest/latin-600-normal.ttf';
var _fontCache = {}; // parsed opentype.Font objects

/* ── Load font + convert title to ClipperLib polygons ── */
var _fontCache = {}; // parsed opentype.Font objects
async function loadFont(fontKey) {
  if (_fontCache[fontKey]) return _fontCache[fontKey];
  var url = FONT_TTF_URLS[fontKey];
  if (!url) return null;
  try {
    var buf = await (await fetch(url)).arrayBuffer();
    var font = opentype.parse(buf);
    _fontCache[fontKey] = font;
    return font;
  } catch(e) { console.warn('Font load failed:', fontKey, e); return null; }
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  DOM HELPERS                                                 ║
   ╚════════════════════════════════════════════════════════════════╝ */

const $ = id => document.getElementById(id);

/* ── Analytics: fires to whichever tracking is already on the page ── */
function trackEvent(name, params) {
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params || {});
    }
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: name }, params || {}));
    }
  } catch (e) { /* analytics should never break the app */ }
}

function getWidthMm()  { return S.unit === 'in' ? S.width  * IN_TO_MM : S.width;  }
function getHeightMm() { return S.unit === 'in' ? S.height * IN_TO_MM : S.height; }

/* ╔════════════════════════════════════════════════════════════════╗
   ║  MAP INIT                                                    ║
   ╚════════════════════════════════════════════════════════════════╝ */

function initMap() {
  // Use OpenFreeMap's pre-built style — guaranteed to work — then customize
  S.map = new maplibregl.Map({
    container: 'map',
    style: 'https://tiles.openfreemap.org/styles/liberty',
    center: [-97, 38],
    zoom: 3,
    attributionControl: false
  });

  // Diagnostics
  var mapEl = $('map');
  console.log('[map-plaque] #map dimensions:', mapEl.clientWidth, '×', mapEl.clientHeight);
  console.log('[map-plaque] mapWrap dimensions:', $('mapWrap').clientWidth, '×', $('mapWrap').clientHeight);

  S.map.on('zoomend', function() {
    S.zoom = Math.round(S.map.getZoom() * 2) / 2;
    $('zoomSlider').value = S.zoom;
    $('zoomVal').textContent = S.zoom;
  });

  S.map.on('load', function() {
    console.log('[map-plaque] Map loaded');
    var style = S.map.getStyle();

    // Strip heavy decorative layers to improve Firefox performance
    // Keep: background, water, waterway, transportation, boundary, place labels, building
    var keepSources = ['water','waterway','transportation','boundary','place','building','landcover','landuse'];
    style.layers.forEach(function(layer) {
      var sl = layer['source-layer'] || '';
      var t = layer.type;
      if (t === 'background') return;
      // Keep essential layers
      var dominated = false;
      for (var ki = 0; ki < keepSources.length; ki++) {
        if (sl.indexOf(keepSources[ki]) >= 0) { dominated = true; break; }
      }
      if (dominated) return;
      // Keep symbol layers (labels, POIs)
      if (t === 'symbol') return;
      // Remove everything else (aeroway, park fills, pattern layers, etc)
      try { S.map.removeLayer(layer.id); } catch(e){}
    });

    // Add overzoom source for road extraction at low zoom
    var srcName = Object.keys(style.sources)[0] || 'openmaptiles';
    var origSrc = style.sources[srcName];
    try {
      S.map.addSource('ofm-overzoom', {
        type: 'vector',
        tiles: origSrc.tiles || ['https://tiles.openfreemap.org/planet/{z}/{x}/{y}.pbf'],
        minzoom: 12,
        maxzoom: 14
      });
      // Add minor road layer from overzoomed source — only renders below zoom 12
      // (above zoom 12, the original layers handle it)
      S.map.addLayer({
        id: 'ovz-minor-roads',
        type: 'line',
        source: 'ofm-overzoom',
        'source-layer': 'transportation',
        maxzoom: 12,
        filter: ['match', ['get', 'class'], ['minor','service','track','path','tertiary','residential','street','pedestrian'], true, false],
        paint: { 'line-color': '#3d2e1e', 'line-width': ['interpolate',['linear'],['zoom'], 5,0.08, 8,0.15, 11,0.4] }
      });
      S.map.addLayer({
        id: 'ovz-main-roads',
        type: 'line',
        source: 'ofm-overzoom',
        'source-layer': 'transportation',
        maxzoom: 12,
        filter: ['match', ['get', 'class'], ['motorway','trunk','primary','secondary'], true, false],
        paint: { 'line-color': '#3d2e1e', 'line-width': ['interpolate',['linear'],['zoom'], 5,0.3, 8,0.5, 11,1.2] }
      });
    } catch(e) { console.warn('[map-plaque] Overzoom source failed:', e.message); }

    setDetail(S.detail);
    applyRoadWidths();
    if (S.gpxCoords) addGPXLayer();
    S.map.resize();
  });


  S.map.on('error', function(e) {
    console.error('[map-plaque] Map error:', e.error || e);
  });
}


/* ╔════════════════════════════════════════════════════════════════╗
   ║  ELEVATION GRID SYSTEM                                       ║
   ╚════════════════════════════════════════════════════════════════╝ */

var _elevCache = null;

function lng2tileX(lng,z){ return ((lng+180)/360)*Math.pow(2,z); }
function lat2tileY(lat,z){
  var r=lat*Math.PI/180;
  return (1-Math.log(Math.tan(r)+1/Math.cos(r))/Math.PI)/2*Math.pow(2,z);
}

function smoothGrid(grid, w, h, radius) {
  var out = new Float32Array(w * h);
  for (var y = 0; y < h; y++) {
    for (var x = 0; x < w; x++) {
      var sum = 0, count = 0;
      var r0 = Math.max(0, y - radius), r1 = Math.min(h - 1, y + radius);
      var c0 = Math.max(0, x - radius), c1 = Math.min(w - 1, x + radius);
      for (var ry = r0; ry <= r1; ry++) {
        for (var rx = c0; rx <= c1; rx++) {
          sum += grid[ry * w + rx];
          count++;
        }
      }
      out[y * w + x] = sum / count;
    }
  }
  return out;
}

function fetchElevationGrid(map, res, cb) {
  var bounds=map.getBounds();
  var z=Math.min(Math.max(Math.floor(map.getZoom()),5),14);
  var x0=Math.floor(lng2tileX(bounds.getWest(),z));
  var x1=Math.floor(lng2tileX(bounds.getEast(),z));
  var y0=Math.floor(lat2tileY(bounds.getNorth(),z));
  var y1=Math.floor(lat2tileY(bounds.getSouth(),z));
  x0=Math.max(0,x0); x1=Math.min(Math.pow(2,z)-1,x1);
  y0=Math.max(0,y0); y1=Math.min(Math.pow(2,z)-1,y1);
  x0=Math.max(0,x0-1); x1=Math.min(Math.pow(2,z)-1,x1+1);
  y0=Math.max(0,y0-1); y1=Math.min(Math.pow(2,z)-1,y1+1);
  var tw=x1-x0+1, th=y1-y0+1;
  var cv=document.createElement('canvas'); cv.width=tw*256; cv.height=th*256;
  var ctx=cv.getContext('2d');
  var loaded=0, total=tw*th;
  for(var ty=y0;ty<=y1;ty++){for(var tx=x0;tx<=x1;tx++){(function(tx,ty){
    var img=new Image(); img.crossOrigin='anonymous';
    img.onload=function(){ctx.drawImage(img,(tx-x0)*256,(ty-y0)*256);loaded++;if(loaded===total)done();};
    img.onerror=function(){loaded++;if(loaded===total)done();};
    img.src='https://s3.amazonaws.com/elevation-tiles-prod/terrarium/'+z+'/'+tx+'/'+ty+'.png';
  })(tx,ty);}}
  function done(){
    var pxW=lng2tileX(bounds.getWest(),z)-x0, pxE=lng2tileX(bounds.getEast(),z)-x0;
    var pxN=lat2tileY(bounds.getNorth(),z)-y0, pxS=lat2tileY(bounds.getSouth(),z)-y0;
    var srcX=pxW*256, srcY=pxN*256, srcW=(pxE-pxW)*256, srcH=(pxS-pxN)*256;
    var mapCanvas = map.getCanvas();
    var mapAR = mapCanvas.clientHeight / mapCanvas.clientWidth;
    var sW=res, sH=Math.round(res * mapAR);
    if(sH<10)sH=10;
    var sv=document.createElement('canvas'); sv.width=sW; sv.height=sH;
    var sctx=sv.getContext('2d');
    sctx.drawImage(cv,srcX,srcY,srcW,srcH,0,0,sW,sH);
    var id=sctx.getImageData(0,0,sW,sH), d=id.data;
    var grid=new Float32Array(sW*sH);
    for(var i=0;i<sW*sH;i++){
      grid[i]=(d[i*4]*256+d[i*4+1]+d[i*4+2]/256)-32768;
    }
    // Clamp: failed tiles decode as -32768, ocean as near-zero — normalize both
    for(var i=0;i<sW*sH;i++){ if(grid[i]<-100) grid[i]=0; if(grid[i]>9000) grid[i]=9000; }
    // 3-pass box blur for smooth organic contours
    grid = smoothGrid(grid, sW, sH, 4);
    grid = smoothGrid(grid, sW, sH, 3);
    grid = smoothGrid(grid, sW, sH, 2);
    var mn=Infinity, mx2=-Infinity;
    for(var i=0;i<sW*sH;i++){ if(grid[i]<mn)mn=grid[i]; if(grid[i]>mx2)mx2=grid[i]; }
    cb({grid:grid,width:sW,height:sH,minEle:mn,maxEle:mx2});
  }
}

function generateLayers() {
  if (!S.map || !S.map.isStyleLoaded()) { $('genStatus').textContent = 'Load a map first'; return; }
  var btn = $('genBtn');
  btn.disabled = true;
  btn.textContent = 'Loading terrain\u2026';
  $('genStatus').textContent = '';

  // Elevation grid resolution: at least 900 for sharpness, more for larger plaques
  var elevRes = Math.max(900, Math.round(700 * (getWidthMm() + getHeightMm()) / 400));
  fetchElevationGrid(S.map, elevRes, function(data) {
    _elevCache = data;
    // Cache all map features NOW while map is fully rendered, AND pre-project their coords
    _cachedRoadFeatures = _preProjectFeatures(_queryFeatures(['transportation'], 'line'));
    _cachedWaterFeatures = _preProjectFeatures(_queryFeatures(['water','waterway'], null));
    _cachedLabelFeatures = _preProjectPoints(_queryLabelFeatures());
    _cachedMapCanvasSize = { w: S.map.getCanvas().clientWidth, h: S.map.getCanvas().clientHeight };
    drawElevCanvas(data);
    $('elevCanvas').style.display = 'block';
    btn.disabled = false;
    btn.textContent = '\u26f0 Generate Layers';
    $('backToMapBtn').style.display = 'block';
    $('preGenControls').style.display = 'none';
    $('postGenControls').style.display = 'block';
    var elevRange = data.maxEle - data.minEle;
    var info = $('elevInfo');
    if (info) {
      info.style.display = 'block';
      if (elevRange < 30) {
        info.style.background = 'rgba(255, 200, 60, 0.12)';
        info.style.color = '#ffd447';
        info.style.border = '1px solid rgba(255, 200, 60, 0.35)';
        info.innerHTML = '\u26a0 <b>Very flat area</b> (' + elevRange.toFixed(0) + 'm range). Terrain layers may look uniform. Try a hillier location.';
      } else {
        info.style.background = 'rgba(115, 137, 109, 0.15)';
        info.style.color = 'rgba(255,255,255,0.75)';
        info.style.border = '1px solid rgba(115, 137, 109, 0.3)';
        info.innerHTML = '\u2713 Elevation range: <b>' + elevRange.toFixed(0) + 'm</b>';
      }
    }
    $('genStatus').textContent = '';
    trackEvent(window.TOPOMAP_DEMO ? 'TopoMap_Demo_generted' : 'TopoMap_generted');
  });
}

// Cached features from MapLibre at generate time (eliminates stale query issues)
var _cachedRoadFeatures = null;
var _cachedWaterFeatures = null;
var _cachedLabelFeatures = null;
var _cachedMapCanvasSize = null;

// Convert map coordinates to fixed pixel coords at capture time
function _preProjectFeatures(features) {
  if (!features || !S.map) return [];
  var map = S.map;
  return features.map(function(f) {
    var g = f.geometry;
    var newG = { type: g.type };
    function projectRing(ring) {
      return ring.map(function(pt) {
        var p = map.project({lng: pt[0], lat: pt[1]});
        return [p.x, p.y];
      });
    }
    if (g.type === 'LineString') {
      newG.coordinates = projectRing(g.coordinates);
    } else if (g.type === 'MultiLineString') {
      newG.coordinates = g.coordinates.map(projectRing);
    } else if (g.type === 'Polygon') {
      newG.coordinates = g.coordinates.map(projectRing);
    } else if (g.type === 'MultiPolygon') {
      newG.coordinates = g.coordinates.map(function(poly) { return poly.map(projectRing); });
    } else {
      newG.coordinates = g.coordinates;
    }
    return { properties: f.properties, geometry: newG };
  });
}

function _preProjectPoints(features) {
  if (!features || !S.map) return [];
  var map = S.map;
  return features.map(function(f) {
    var g = f.geometry;
    if (g.type === 'Point') {
      var p = map.project({lng: g.coordinates[0], lat: g.coordinates[1]});
      return { properties: f.properties, geometry: { type: 'Point', coordinates: [p.x, p.y] }, _lngLat: g.coordinates };
    }
    return { properties: f.properties, geometry: g, _lngLat: null };
  });
}

function _queryFeatures(sourceLayers, geomType) {
  if (!S.map || !S.map.isStyleLoaded()) return [];
  var layerIds = [];
  S.map.getStyle().layers.forEach(function(l) {
    if (sourceLayers.indexOf(l['source-layer']) < 0) return;
    if (geomType && l.type !== geomType) return;
    layerIds.push(l.id);
  });
  // Overzoom road layers
  if (sourceLayers.indexOf('transportation') >= 0) {
    ['ovz-minor-roads','ovz-main-roads'].forEach(function(id){
      try { if(S.map.getLayer(id)) layerIds.push(id); } catch(e){}
    });
  }
  if (!layerIds.length) return [];
  try { return S.map.queryRenderedFeatures(undefined, { layers: layerIds }); } catch(e) { return []; }
}

function _queryLabelFeatures() {
  if (!S.map || !S.map.isStyleLoaded()) return [];
  var ids = [];
  S.map.getStyle().layers.forEach(function(l) {
    if (l.type !== 'symbol') return;
    var sl = l['source-layer'] || '';
    if (sl.indexOf('place') >= 0 || sl.indexOf('poi') >= 0 || sl.indexOf('transportation_name') >= 0) {
      ids.push(l.id);
    }
  });
  if (!ids.length) S.map.getStyle().layers.forEach(function(l) { if (l.type === 'symbol') ids.push(l.id); });
  if (!ids.length) return [];
  try { return S.map.queryRenderedFeatures(undefined, { layers: ids }); } catch(e) { return []; }
}

function drawElevCanvas(data) {
  var cv=$('elevCanvas');
  if(!cv)return;
  var w=data.width, h=data.height;
  cv.width=w; cv.height=h;
  var ctx=cv.getContext('2d');
  var id=ctx.createImageData(w,h);
  var pix=id.data;
  var n=S.depthLayers;
  var range=data.maxEle-data.minEle;
  if(range<1)range=1;
  var colorSet = DEPTH_COLORS.slice(0, n);
  var colors=colorSet.map(function(c){
    return [parseInt(c.substr(1,2),16),parseInt(c.substr(3,2),16),parseInt(c.substr(5,2),16)];
  });
  // Coverage-based percentile thresholds - cache sorted grid on data
  if (!data._sortedGrid) {
    data._sortedGrid = Array.from(data.grid).sort(function(a,b){return a-b;});
  }
  var sorted = data._sortedGrid;
  var pctls = [];
  if (n >= 2) pctls.push(1 - S.cov2/100);
  if (n >= 3) pctls.push(1 - S.cov3/100);
  if (n >= 4) pctls.push(1 - S.cov4/100);
  var thresholds = pctls.map(function(p){
    var idx2 = Math.floor(p * sorted.length);
    return sorted[Math.min(idx2, sorted.length-1)];
  });
  data._thresholds = thresholds;

  // Compute band mask (for road-under-terrain compositing)
  _bandMask = new Uint8Array(w * h);
  for(var i=0;i<w*h;i++){
    var ele=data.grid[i];
    var band=0;
    for(var bi=0;bi<thresholds.length;bi++){
      if(ele>=thresholds[bi]) band=bi+1;
    }
    _bandMask[i] = band;
    var c=colors[band];
    pix[i*4]=c[0]; pix[i*4+1]=c[1]; pix[i*4+2]=c[2]; pix[i*4+3]=255;
  }
  ctx.putImageData(id,0,0);
  // Draw contour lines
  if(S.contourLines && range > 5) {
    ctx.strokeStyle = n===1 ? 'rgba(61,46,30,0.5)' : 'rgba(61,46,30,0.45)';
    ctx.lineWidth = n===1 ? 1.2 : 1;
    var steps = CONTOUR_STEPS[S.contourDensity] || 8;
    for(var s=1;s<steps;s++){
      var thresh=data.minEle+(s/steps)*range;
      drawContourLine(ctx,data,thresh,w,h);
    }
  }
  // Draw water on top
  if(S.map) drawWaterOnCanvas(ctx, w, h);
  // Cache the clean terrain+contours+water for fast road/label redraws
  _terrainImageData = ctx.getImageData(0, 0, w, h);
  // Overlay roads, labels, then mask with higher terrain, then frame/compass/title
  _applyOverlays(ctx, w, h);
}

function fastRedrawOverlays() {
  // Only rebuilds roads/labels/frame - reuses cached terrain
  if (!_terrainImageData || !_elevCache) return false;
  var cv = $('elevCanvas');
  if (!cv) return false;
  var ctx = cv.getContext('2d');
  if (cv.width !== _terrainImageData.width || cv.height !== _terrainImageData.height) return false;
  ctx.putImageData(_terrainImageData, 0, 0);
  _applyOverlays(ctx, cv.width, cv.height);
  return true;
}

var _terrainImageData = null;
var _bandMask = null;

function _applyOverlays(ctx, w, h) {
  // Draw roads/GPX/labels to offscreen canvas
  var off = document.createElement('canvas');
  off.width = w; off.height = h;
  var octx = off.getContext('2d');
  if(S.roadsVisible && S.map) drawRoadsOnCanvas(octx, w, h);
  if(S.gpxCoords && S.map) drawGPXOnCanvas(octx, w, h);
  drawLabelsOnCanvas(octx, w, h);

  // Mask overlay: only keep pixels where band mask says lowest terrain (band 0)
  if (_bandMask && _bandMask.length === w * h) {
    var offImg = octx.getImageData(0, 0, w, h);
    var oPx = offImg.data;
    for (var mi = 0; mi < _bandMask.length; mi++) {
      if (_bandMask[mi] >= 1) {
        oPx[mi * 4 + 3] = 0;
      }
    }
    octx.putImageData(offImg, 0, 0);
  }
  ctx.drawImage(off, 0, 0);

  // Frame, compass, title always on top
  drawFrameOnCanvas(ctx, w, h);
  drawCompassOnCanvas(ctx, w, h);
  drawTitleOnCanvas(ctx, w, h);
}

function drawLabelsOnCanvas(ctx, cw, ch) {
  if (!S.labelsVisible || !S.map || !_cachedLabelFeatures || !_cachedMapCanvasSize) return;
  var features = _cachedLabelFeatures;
  if (!features.length) return;
  ctx.save();
  var mapW = _cachedMapCanvasSize.w, mapH = _cachedMapCanvasSize.h;
  var sx = cw / mapW, sy = ch / mapH;
  var fontSize = S.labelSzPx;
  ctx.font = '600 ' + fontSize + 'px Inter,Helvetica,sans-serif';
  ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  var padX = fontSize * 0.4, padY = fontSize * 0.25;
  var seen = {};
  // Collect labels for backer + text rendering
  var labels = [];
  features.forEach(function(f) {
    var name = f.properties.name || f.properties['name:en'] || '';
    if (!name || name.length > 25) return;
    // Only Point geometry labels
    if (!f.geometry || f.geometry.type !== 'Point') return;
    var coords = f.geometry.coordinates;
    if (!coords || typeof coords[0] !== 'number') return;
    var lngLat = f._lngLat || coords;
    var key = name + '|' + (typeof lngLat[0] === 'number' ? lngLat[0].toFixed(3) : String(lngLat[0]));
    if (seen[key]) return; seen[key] = true;
    // coords is pre-projected [x, y] in map canvas pixels
    var px2 = coords[0] * sx, py2 = coords[1] * sy;
    if (px2 < 0 || px2 > cw || py2 < 0 || py2 > ch) return;
    var tw = ctx.measureText(name).width;
    labels.push({name: name, x: px2, y: py2, w: tw});
  });
  // Draw backers first (beige rectangles)
  ctx.fillStyle = '#cfc5a6';
  labels.forEach(function(lb) {
    ctx.fillRect(lb.x - lb.w/2 - padX, lb.y - fontSize/2 - padY, lb.w + padX*2, fontSize + padY*2);
  });
  // Draw text on top
  ctx.fillStyle = '#3d2e1e';
  labels.forEach(function(lb) {
    ctx.fillText(lb.name, lb.x, lb.y);
  });
  ctx.restore();
}

function redrawPreview() {
  if (!_elevCache) return;
  drawElevCanvas(_elevCache);
}

function drawContourLine(ctx,data,threshold,w,h) {
  for(var y=0;y<h-1;y++){
    for(var x=0;x<w-1;x++){
      var tl=data.grid[y*w+x]>=threshold?1:0;
      var tr=data.grid[y*w+x+1]>=threshold?1:0;
      var br=data.grid[(y+1)*w+x+1]>=threshold?1:0;
      var bl=data.grid[(y+1)*w+x]>=threshold?1:0;
      var c2=tl*8+tr*4+br*2+bl;
      if(c2===0||c2===15)continue;
      var vTL=data.grid[y*w+x],vTR=data.grid[y*w+x+1];
      var vBR=data.grid[(y+1)*w+x+1],vBL=data.grid[(y+1)*w+x];
      var t2;
      t2=(threshold-vTL)/(vTR-vTL);if(t2<0)t2=0;if(t2>1)t2=1;var top2=[x+t2,y];
      t2=(threshold-vTR)/(vBR-vTR);if(t2<0)t2=0;if(t2>1)t2=1;var right2=[x+1,y+t2];
      t2=(threshold-vBL)/(vBR-vBL);if(t2<0)t2=0;if(t2>1)t2=1;var bottom2=[x+t2,y+1];
      t2=(threshold-vTL)/(vBL-vTL);if(t2<0)t2=0;if(t2>1)t2=1;var left2=[x,y+t2];
      var segs=[];
      if(c2===1||c2===14){segs.push(left2,bottom2);}
      else if(c2===2||c2===13){segs.push(bottom2,right2);}
      else if(c2===3||c2===12){segs.push(left2,right2);}
      else if(c2===4||c2===11){segs.push(top2,right2);}
      else if(c2===6||c2===9){segs.push(top2,bottom2);}
      else if(c2===7||c2===8){segs.push(top2,left2);}
      else if(c2===5){segs.push(left2,top2,bottom2,right2);}
      else if(c2===10){segs.push(top2,right2,left2,bottom2);}
      for(var si=0;si<segs.length;si+=2){
        ctx.beginPath();ctx.moveTo(segs[si][0],segs[si][1]);
        ctx.lineTo(segs[si+1][0],segs[si+1][1]);ctx.stroke();
      }
    }
  }
}

function drawWaterOnCanvas(ctx, cw, ch) {
  if (!_cachedWaterFeatures || !_cachedMapCanvasSize) return;
  var features = _cachedWaterFeatures;
  if (!features.length) return;
  ctx.save();
  var mapW = _cachedMapCanvasSize.w, mapH = _cachedMapCanvasSize.h;
  var sx = cw / mapW, sy = ch / mapH;
  ctx.fillStyle = WATER_COLOR;
  features.forEach(function(f) {
    var geom = f.geometry;
    var rings = [];
    if (geom.type === 'Polygon') rings = geom.coordinates;
    else if (geom.type === 'MultiPolygon') { geom.coordinates.forEach(function(pp){ rings = rings.concat(pp); }); }
    if (!rings.length) return;
    ctx.beginPath();
    rings.forEach(function(ring) {
      if (ring.length < 3) return;
      for (var i = 0; i < ring.length; i++) {
        var cx2 = ring[i][0] * sx, cy2 = ring[i][1] * sy;
        if (i === 0) ctx.moveTo(cx2, cy2);
        else ctx.lineTo(cx2, cy2);
      }
      ctx.closePath();
    });
    ctx.fill();
  });
  ctx.restore();
}

function drawRoadsOnCanvas(ctx, cw, ch) {
  var map = S.map;
  if (!map || !_cachedRoadFeatures || !_cachedMapCanvasSize) return;
  // Filter by detail level
  var mainClasses = ['motorway','trunk'];
  var medClasses = ['motorway','trunk','primary','secondary','tertiary'];
  var features = _cachedRoadFeatures.filter(function(f) {
    var cls = (f.properties && f.properties.class) || '';
    if (S.detail === 'low') return mainClasses.indexOf(cls) >= 0;
    if (S.detail === 'med') return medClasses.indexOf(cls) >= 0;
    return true;
  });
  if (!features.length) return;
  ctx.save();
  var mapW = _cachedMapCanvasSize.w, mapH = _cachedMapCanvasSize.h;
  var sx = cw / mapW, sy = ch / mapH;
  ctx.strokeStyle = 'rgba(40,30,20,0.55)';
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  features.forEach(function(f) {
    var geom = f.geometry;
    var lines = [];
    if (geom.type === 'LineString') lines.push(geom.coordinates);
    else if (geom.type === 'MultiLineString') lines = geom.coordinates;
    // Class-based base width in canvas pixels — matches SVG mm proportions
    var cls = (f.properties && f.properties.class) || '';
    var classW = { motorway:2.0, trunk:1.7, primary:1.4, secondary:1.1, tertiary:0.85 };
    var baseW = classW[cls] || 0.6;
    var detailScale = getDetailScale();
    baseW *= detailScale;
    var isMain = (cls==='motorway'||cls==='trunk'||cls==='primary'||cls==='secondary');
    var mult = isMain ? S.mainRoadWidth : S.sideRoadWidth;
    ctx.lineWidth = baseW * mult;
    lines.forEach(function(coords) {
      if (coords.length < 2) return;
      ctx.beginPath();
      for (var i = 0; i < coords.length; i++) {
        // coords[i] is already [x, y] in map canvas pixel space
        var cx2 = coords[i][0] * sx, cy2 = coords[i][1] * sy;
        if (i === 0) ctx.moveTo(cx2, cy2);
        else ctx.lineTo(cx2, cy2);
      }
      ctx.stroke();
    });
  });
  ctx.restore();
}


function backToMap() {
  $('elevCanvas').style.display = 'none';
  $('backToMapBtn').style.display = 'none';
  $('preGenControls').style.display = 'block';
  $('postGenControls').style.display = 'none';
  $('genBtn').textContent = '\u26f0 Generate Layers';
  $('genStatus').textContent = 'Adjust map position, then generate again';
  if ($('elevInfo')) $('elevInfo').style.display = 'none';
  // Clear cached features so next generate captures fresh data
  _cachedRoadFeatures = null;
  _cachedWaterFeatures = null;
  _cachedLabelFeatures = null;
  _cachedMapCanvasSize = null;
}

function drawGPXOnCanvas(ctx, cw, ch) {
  if (!S.gpxCoords || S.gpxCoords.length < 2 || !S.map) return;
  var map = S.map;
  var canvas = map.getCanvas();
  var mapW = canvas.clientWidth, mapH = canvas.clientHeight;
  var sx = cw / mapW, sy = ch / mapH;
  ctx.strokeStyle = '#000000';
  ctx.lineWidth = 2.5;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.beginPath();
  for (var i = 0; i < S.gpxCoords.length; i++) {
    var px = map.project({lng: S.gpxCoords[i][0], lat: S.gpxCoords[i][1]});
    var cx2 = px.x * sx, cy2 = px.y * sy;
    if (i === 0) ctx.moveTo(cx2, cy2);
    else ctx.lineTo(cx2, cy2);
  }
  ctx.stroke();
}

function clearElevPreview() {
  _elevCache = null;
  $('elevCanvas').style.display = 'none';
  $('backToMapBtn').style.display = 'none';
  $('genStatus').textContent = '';
}

function adjCov(layer, delta) {
  if (layer === 2) {
    S.cov2 = Math.max(10, Math.min(80, S.cov2 + delta));
    $('cov2Val').textContent = S.cov2 + '%';
  } else if (layer === 3) {
    S.cov3 = Math.max(5, Math.min(50, S.cov3 + delta));
    $('cov3Val').textContent = S.cov3 + '%';
  } else if (layer === 4) {
    S.cov4 = Math.max(3, Math.min(30, S.cov4 + delta));
    $('cov4Val').textContent = S.cov4 + '%';
  }
  if (_elevCache) {
    drawElevCanvas(_elevCache);
    _terrainImageData = null;
  }
}

var CONTOUR_LABELS = ['Fewest','Fewer','Normal','More','Most'];
var CONTOUR_STEPS = [3, 5, 8, 12, 18];
function adjContourDensity(d) {
  S.contourDensity = Math.max(0, Math.min(4, S.contourDensity + d));
  $('contourDensityVal').textContent = CONTOUR_LABELS[S.contourDensity];
  _terrainImageData = null;
  redrawPreview();
}

var THICK_LABELS = ['Thinnest','Thin','Normal','Thick','Thickest'];
var THICK_MULTS = [0.4, 0.7, 1.0, 1.5, 2.0];
function adjRoadThick(d) {
  S.roadThickIdx = Math.max(0, Math.min(4, S.roadThickIdx + d));
  $('roadThickVal').textContent = THICK_LABELS[S.roadThickIdx];
  S.mainRoadWidth = THICK_MULTS[S.roadThickIdx];
  S.sideRoadWidth = THICK_MULTS[S.roadThickIdx];
  applyRoadWidths();
  if (!fastRedrawOverlays()) { _terrainImageData = null; redrawPreview(); }
}

function adjLabelSz(d) {
  S.labelSzPx = Math.max(4, Math.min(40, S.labelSzPx + d));
  $('labelSzVal').textContent = S.labelSzPx + ' px';
  if (!fastRedrawOverlays()) { _terrainImageData = null; redrawPreview(); }
}

function toggleLabels(on) {
  S.labelsVisible = on;
  if (!fastRedrawOverlays()) { _terrainImageData = null; redrawPreview(); }
}

function setDepthLayers(n) {
  S.depthLayers = parseInt(n);
  $('cov2Row').querySelectorAll('.step-btn').forEach(function(b){b.disabled=n<2;b.style.opacity=n>1?'1':'0.3';});
  $('cov2Row').querySelectorAll('.step-val,.cov-label').forEach(function(e){e.style.opacity=n>1?'1':'0.3';});
  $('cov3Row').querySelectorAll('.step-btn').forEach(function(b){b.disabled=n<3;b.style.opacity=n>2?'1':'0.3';});
  $('cov3Row').querySelectorAll('.step-val,.cov-label').forEach(function(e){e.style.opacity=n>2?'1':'0.3';});
  $('cov4Row').querySelectorAll('.step-btn').forEach(function(b){b.disabled=n<4;b.style.opacity=n>3?'1':'0.3';});
  $('cov4Row').querySelectorAll('.step-val,.cov-label').forEach(function(e){e.style.opacity=n>3?'1':'0.3';});
  if(_elevCache) {
    drawElevCanvas(_elevCache);
    $('genStatus').textContent = '\u2713 ' + S.depthLayers + ' layers — click Generate to update';
  }
}

function subsampleGrid(data, targetW) {
  var step = Math.max(1, Math.round(data.width / targetW));
  var nw = Math.ceil(data.width / step);
  var nh = Math.ceil(data.height / step);
  var ng = new Float32Array(nw * nh);
  for (var sy = 0; sy < nh; sy++) {
    for (var sx = 0; sx < nw; sx++) {
      ng[sy*nw+sx] = data.grid[Math.min(sy*step,data.height-1)*data.width+Math.min(sx*step,data.width-1)];
    }
  }
  return {grid:ng, width:nw, height:nh, minEle:data.minEle, maxEle:data.maxEle, _thresholds:data._thresholds};
}

function elevationToPolygons(data, threshold) {
  if(!hasClipper()) return [];
  var w=data.width, h=data.height, grid=data.grid;
  var rects=[];
  var CS2=1000;
  for(var y=0;y<h;y++){
    var inSpan=false, sx=0;
    for(var x=0;x<=w;x++){
      var above = x<w && grid[y*w+x]>=threshold;
      if(above&&!inSpan){sx=x;inSpan=true;}
      if(!above&&inSpan){
        rects.push([
          {X:sx*CS2,Y:y*CS2},{X:x*CS2,Y:y*CS2},
          {X:x*CS2,Y:(y+1)*CS2},{X:sx*CS2,Y:(y+1)*CS2}
        ]);
        inSpan=false;
      }
    }
  }
  if(!rects.length) return [];
  var cpr=new ClipperLib.Clipper();
  cpr.AddPaths(rects,ClipperLib.PolyType.ptSubject,true);
  var sol=new ClipperLib.Paths();
  cpr.Execute(ClipperLib.ClipType.ctUnion,sol,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  sol=ClipperLib.Clipper.SimplifyPolygons(sol,ClipperLib.PolyFillType.pftNonZero);
  // Smooth jagged edges: offset shrink then expand (rounds corners)
  var smoothAmt = 3.0 * CS2;
  var co1 = new ClipperLib.ClipperOffset(2, 0.15 * CS2);
  co1.AddPaths(sol, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
  var shrunk = new ClipperLib.Paths();
  co1.Execute(shrunk, -smoothAmt);
  var co2 = new ClipperLib.ClipperOffset(2, 0.15 * CS2);
  co2.AddPaths(shrunk, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
  var expanded = new ClipperLib.Paths();
  co2.Execute(expanded, smoothAmt);
  var result=[];
  for(var p=0;p<expanded.length;p++){
    var poly=[];
    for(var j=0;j<expanded[p].length;j++){
      poly.push([expanded[p][j].X/CS2, expanded[p][j].Y/CS2]);
    }
    result.push(poly);
  }
  return result;
}


/* ╔════════════════════════════════════════════════════════════════╗
   ║  COMPASS, FRAME, TITLE                                       ║
   ╚════════════════════════════════════════════════════════════════╝ */

var COMPASS_SVG = '<path d="M338.659,123.74c-27.17-27.021-60.29-41.128-98.528-43.504c-2.452-10.842-4.85-21.448-7.249-32.055 c-0.222,0.028-0.445,0.055-0.667,0.083c-2.374,10.681-4.748,21.361-7.127,32.064c-38.043,2.742-70.697,16.983-97.495,43.817 c-26.859,26.895-41.102,59.644-43.703,97.641c-10.902,2.389-21.623,4.738-32.345,7.087c0.026,0.239,0.052,0.478,0.077,0.717 c10.782,2.387,21.565,4.773,32.233,7.134c2.466,38.474,16.666,71.355,43.564,98.372c26.957,27.076,59.87,41.421,98.096,43.993 c2.396,10.84,4.764,21.554,7.132,32.268c0.188,0.024,0.376,0.048,0.564,0.072c2.383-10.761,4.767-21.523,7.157-32.314 c38.448-2.378,71.498-16.666,98.593-43.748c27.153-27.139,41.494-60.269,43.799-98.676c10.996-2.42,21.712-4.777,32.428-7.135 c0.011-0.218,0.022-0.436,0.033-0.654c-10.784-2.336-21.569-4.672-32.504-7.041C380.166,183.571,365.753,150.685,338.659,123.74z M223.015,88.637c-0.02,2.135-0.571,3.957-1.202,5.999c-32.839,3.17-61.167,16.134-84.431,39.463 c-23.208,23.271-36.051,51.563-39.221,84.334c-1.95,0.697-3.842,1.255-5.888,1.205C94.837,153.072,152.639,92.23,223.015,88.637z M150.727,146.175c-0.206,0.173-0.412,0.346-0.618,0.519c11.285,17.555,22.57,35.111,34.171,53.159 c-24.041,5.25-47.646,10.404-71.883,15.696c3.448-26.513,13.79-49.235,31.624-68.412c20.135-21.651,44.975-34.29,74.814-38.259 c-5.29,23.976-10.469,47.446-15.753,71.394C185.345,168.721,168.036,157.448,150.727,146.175z M202.699,182.93 c-0.803,4.392-1.587,8.678-2.483,13.576c-13.799-13.556-27.135-26.658-40.471-39.759c0.127-0.168,0.254-0.336,0.381-0.504 C174.242,165.091,188.359,173.94,202.699,182.93z M75.205,229.307c-0.997,0-1.993,0-2.99,0c-0.035-0.265-0.07-0.53-0.104-0.796 c43.394-8.602,86.788-17.205,130.212-25.813c6.598,5.77,13.066,11.428,19.535,17.084c2.855,2.497,5.714,4.99,8.568,7.488 c0.737,0.645,1.561,1.244,1.46,2.381c-1.198-0.636-2.497-0.325-3.744-0.325C177.163,229.305,126.184,229.307,75.205,229.307z M150.446,313.388c17.521-11.574,35.042-23.148,53.011-35.018c5.31,24.208,10.52,47.964,15.748,71.799 c-50.462-3.844-101.011-48.047-106.656-107.186c24.109,5.292,47.89,10.511,72.185,15.844 c-11.752,18.288-23.255,36.187-34.757,54.087C150.134,313.072,150.29,313.23,150.446,313.388z M159.335,301.804 c8.69-13.535,17.862-27.819,27.148-42.283c4.105,1.182,8.069,2.323,11.847,3.411C185.111,276.109,171.94,289.239,159.335,301.804z M133.835,330.601c-29.246-28.459-41.3-66.425-41.624-91.863c1.943,0.023,3.762,0.571,5.826,1.146 c3.008,33.024,15.766,61.703,39.248,85.294c23.409,23.519,51.894,36.473,84.782,39.638c1.031,2.397,1.274,3.552,1.277,6.314 C188.619,368.267,158.769,354.864,133.835,330.601z M232.664,390.964c0,0.524-0.094,1.047-0.561,1.617 c-9.622-45.424-19.243-90.849-28.907-136.471c3.029-2.763,6.015-5.506,9.023-8.227c5.831-5.275,11.685-10.527,17.501-15.819 c0.776-0.706,1.778-1.23,2.187-2.291c1.162,0.508,0.747,1.565,0.747,2.405C232.672,285.106,232.671,338.035,232.664,390.964z M326.131,122.696c29.266,25.597,45.29,58.025,48.646,96.792c-2.425,0.259-3.141,0.14-6.337-1.007 c-3.056-32.989-16.14-61.536-39.774-84.952c-23.56-23.342-52.16-36.117-85.148-39.023c-0.804-2-1.177-3.858-1.373-6.246 C274.11,90.495,302.192,101.758,326.131,122.696z M316.28,146.614c-0.142-0.184-0.284-0.368-0.426-0.552 c-17.656,11.246-35.312,22.491-53.432,34.032c-5.346-23.914-10.59-47.37-15.947-71.334c27.217,3.187,50.505,13.817,70.09,32.277 c21.371,20.143,33.82,44.903,37.702,74.667c-24.204-5.22-47.901-10.331-72.178-15.567 C293.708,181.948,304.994,164.281,316.28,146.614z M279.269,199.894c-4.497-1.218-8.742-2.367-12.764-3.456 c13.301-13.293,26.523-26.508,39.169-39.147C297.264,170.86,288.362,185.223,279.269,199.894z M233.324,66.818 c0.111-0.023,0.222-0.046,0.333-0.069c9.894,45.353,19.787,90.705,29.704,136.164c-9.981,8.64-19.82,17.156-30.038,26 C233.324,174.571,233.324,120.695,233.324,66.818z M344.815,317.096c-26.078,32.77-60.332,50.502-102.474,54.186 c0.137-1.296,0.159-2.03,0.303-2.739c0.237-1.163,0.553-2.31,0.876-3.628c33.296-3.014,62.022-15.889,85.617-39.518 c23.531-23.566,36.454-52.18,39.368-85.19c0.953-0.831,1.992-0.902,2.971-1.115c0.895-0.195,1.804-0.328,3.296-0.592 C372.856,267.994,363.007,294.236,344.815,317.096z M262.428,278.164c18.04,11.873,35.682,23.483,53.323,35.093 c0.178-0.15,0.356-0.299,0.534-0.449c-11.346-17.856-22.692-35.711-34.379-54.103c24.328-5.317,48.108-10.515,72.435-15.832 c-3.507,28.869-15.194,53.129-35.348,73.162c-19.879,19.76-43.926,31.11-72.436,34.674 C251.895,326.312,257.11,302.471,262.428,278.164z M262.383,275.129c1.098-4.556,2.09-8.668,3.06-12.694 c13.418,13.705,26.798,27.372,37.625,38.432C291.714,293.684,277.121,284.453,262.383,275.129z M262.468,254.569 c-9.438-8.191-18.899-16.402-28.524-24.755c2.887-0.751,158.569-0.725,160.993-0.071 C392.556,230.445,265.89,254.215,262.468,254.569z"/><path d="M45.572,212.585c-1.732,7.026-3.442,13.962-5.152,20.898c-0.221-0.004-0.442-0.009-0.664-0.013 c-1.655-6.954-3.31-13.908-4.963-20.859c-1.933-0.276-3.553-0.385-5.393,0.074c-1.705,6.962-3.414,13.935-5.122,20.908 c-0.174,0.009-0.348,0.019-0.522,0.028c-1.82-7.018-3.64-14.036-5.514-21.259c-1.715,0.182-3.325-0.38-5.075,0.446 c2.199,8.72,4.358,17.281,6.523,25.866c2.632,0.247,4.985,0.387,7.493-0.111c1.495-5.474,2.973-10.882,4.45-16.289 c0.19,0.019,0.381,0.038,0.571,0.056c1.471,5.485,2.942,10.97,4.405,16.425c2.552,0.126,4.744,0.304,7.143-0.137 c2.148-8.637,4.295-17.267,6.454-25.945C48.486,212.221,47.22,212.319,45.572,212.585z"/><path d="M225.389,37.909c0-6.944,0-13.947,0-20.951c0.17-0.021,0.34-0.042,0.51-0.063c4.007,7.146,8.014,14.293,12.051,21.492 c1.949-0.144,3.681,0.3,5.439-0.343c0-9.247,0-18.414,0-27.62c-1.678-0.164-3.116-0.448-4.762,0.306c0,6.137,0,12.264,0,18.392 c-0.188,0.055-0.375,0.109-0.563,0.164c-3.632-6.352-7.264-12.703-10.843-18.961c-2.329,0-4.352,0-6.643,0 c0,9.304,0,18.534,0,27.955C222.177,38.323,223.611,38.624,225.389,37.909z"/><path d="M241.509,436.792c-2.469-1.847-5.379-2.839-8.151-4.097c-1.681-0.763-3.404-1.475-4.706-2.856 c-1.84-1.951-1.374-4.333,1.034-5.393c4.07-1.792,7.919-0.299,9.604,3.785c1.507,0.173,3.042,0.397,4.633-0.202 c0.316-2.636-1.036-4.356-3.176-5.287c-5.065-2.204-10.312-2.275-15.339-0.038c-4.13,1.838-4.466,6.377-0.924,9.184 c2.199,1.742,4.836,2.675,7.353,3.826c1.929,0.882,3.965,1.603,5.529,3.107c1.842,1.772,1.585,4.145-0.512,5.344 c-4.334,2.478-9.149,0.46-10.182-4.417c-1.398,0-2.836,0-4.467,0c-0.435,3.42,0.401,5.336,3.196,6.465 c4.993,2.016,10.128,2.128,15.1,0.004C244.977,444.304,245.393,439.699,241.509,436.792z"/><path d="M444.156,236.697c-4.439,0-9.19,0-14.116,0c-0.061-3.467-0.344-6.549,0.238-9.914c3.97,0,7.721,0,11.331,0 c0.447-1.02,0.5-1.717-0.139-2.77c-3.606,0-7.429,0-11.367,0c0-3.289,0-6.207,0-9.604c5.067,0,9.747,0,14.216,0 c0.653-0.995,0.639-1.684,0.186-2.526c-6.534,0-13.131,0-19.799,0c0,9.297,0,18.386,0,27.607c6.751,0,13.277,0,19.873,0 C444.827,238.59,445.149,237.825,444.156,236.697z"/>';

var FRAME_LEVELS = ['Off', 'Thin', 'Normal', 'Thick', 'Extra'];
var FRAME_SIZES = [0, 0.01, 0.02, 0.035, 0.05]; // as fraction of width
var frameIdx = 2; // default Normal

function adjFrame(d) {
  frameIdx = Math.max(0, Math.min(FRAME_LEVELS.length - 1, frameIdx + d));
  S.frameThickness = FRAME_SIZES[frameIdx];
  $('frameVal').textContent = FRAME_LEVELS[frameIdx];
  redrawPreview();
}

function adjCompassSz(d) {
  S.compassSize = Math.max(0.4, Math.min(2.5, S.compassSize + d * 0.15));
  redrawPreview();
}

function adjTitleSz(d) {
  S.titleSzMult = Math.max(0.3, Math.min(3.0, S.titleSzMult + d * 0.15));
  redrawPreview();
}
function setTitleFont(v) {
  S.titleFont = v;
  $('titleFontSelect').style.fontFamily = v;
  redrawPreview();
}

function nudgeTitle(dx, dy) {
  if (dx === 0 && dy === 0) { S.titleDx = 0; S.titleDy = 0; } // reset
  else { S.titleDx += dx * 2; S.titleDy += dy * 2; }
  redrawPreview();
}

function drawCompassOnCanvas(ctx, cw, ch) {
  if (S.compassCorner === 'off') return;
  ctx.save();
  var L = _compassLayout(cw, ch);
  // Rounded square backer
  ctx.fillStyle = '#d8d2c0';
  ctx.beginPath();
  _canvasRR(ctx, L.cx - L.bSz/2, L.cy - L.bSz/2, L.bSz, L.bSz, L.bR);
  ctx.fill();
  // Render compass SVG paths via Path2D (centered within backer)
  ctx.save();
  ctx.translate(L.cx - L.sz/2, L.cy - L.sz/2);
  ctx.scale(L.scale, L.scale);
  ctx.fillStyle = '#594a42';
  var dAttrs = COMPASS_SVG.match(/d="([^"]+)"/g);
  if (dAttrs) {
    for (var ci2 = 0; ci2 < dAttrs.length; ci2++) {
      var dStr = dAttrs[ci2].slice(3, -1);
      try { ctx.fill(new Path2D(dStr)); } catch(e) {}
    }
  }
  ctx.restore();
  ctx.restore();
}

function drawTitleOnCanvas(ctx, cw, ch) {
  ctx.save();
  var title = $('titleInput') ? $('titleInput').value : '';
  if (!title) { ctx.restore(); return; }
  var tSz = Math.min(cw, ch) * 0.055 * S.titleSzMult;
  var lineGap = 1.3;
  var ox = cw * S.titleDx / 100, oy = ch * S.titleDy / 100;
  var baseX = tSz * 0.5 + ox;
  var totalTextH = tSz * lineGap;
  var baseY = ch - totalTextH - tSz * 0.4 + oy;

  // Offset backer (like reference generator)
  var strokeW = tSz * 0.35;
  var y = baseY + tSz * 0.9;
  ctx.font = '800 ' + tSz.toFixed(0) + 'px ' + S.titleFont;
  ctx.textAlign = 'left';
  ctx.textBaseline = 'alphabetic';
  ctx.strokeStyle = '#d8d2c0';
  ctx.lineWidth = strokeW;
  ctx.lineJoin = 'round';
  ctx.strokeText(title, baseX, y);
  ctx.fillStyle = '#594a42';
  ctx.fillText(title, baseX, y);
  ctx.restore();
}

function drawFrameOnCanvas(ctx, cw, ch) {
  if (S.frameThickness <= 0) return;
  ctx.save();
  var fw = Math.max(1, cw * S.frameThickness);
  var cr = 0 / getWidthMm() * cw;
  var outerR = Math.min(cr, cw/2, ch/2);
  var innerR = Math.max(0, outerR - fw);
  ctx.fillStyle = '#d8d2c0';
  ctx.beginPath();
  // Outer rounded rect
  _canvasRR(ctx, 0, 0, cw, ch, outerR);
  // Inner rounded rect (evenodd punches a hole)
  _canvasRR(ctx, fw, fw, cw - 2*fw, ch - 2*fw, innerR);
  ctx.fill('evenodd');
  ctx.restore();
}

function _canvasRR(ctx, x, y, w, h, r) {
  r = Math.min(r, w/2, h/2);
  if (r <= 0) { ctx.rect(x, y, w, h); return; }
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

/* ── SVG rounded rect path d ── */
function _rrD(x, y, w, h, r) {
  r = Math.min(r, w/2, h/2);
  if (r <= 0) return 'M'+x.toFixed(2)+','+y.toFixed(2)+'L'+(x+w).toFixed(2)+','+y.toFixed(2)+'L'+(x+w).toFixed(2)+','+(y+h).toFixed(2)+'L'+x.toFixed(2)+','+(y+h).toFixed(2)+'Z';
  var R = r.toFixed(2);
  return 'M'+(x+r).toFixed(2)+','+y.toFixed(2)+
    'L'+(x+w-r).toFixed(2)+','+y.toFixed(2)+
    'A'+R+','+R+' 0 0 1 '+(x+w).toFixed(2)+','+(y+r).toFixed(2)+
    'L'+(x+w).toFixed(2)+','+(y+h-r).toFixed(2)+
    'A'+R+','+R+' 0 0 1 '+(x+w-r).toFixed(2)+','+(y+h).toFixed(2)+
    'L'+(x+r).toFixed(2)+','+(y+h).toFixed(2)+
    'A'+R+','+R+' 0 0 1 '+x.toFixed(2)+','+(y+h-r).toFixed(2)+
    'L'+x.toFixed(2)+','+(y+r).toFixed(2)+
    'A'+R+','+R+' 0 0 1 '+(x+r).toFixed(2)+','+y.toFixed(2)+'Z';
}

/* ── Rounded rect as polygon pts (for ClipperLib) ── */
function _rrPts(x, y, w, h, r) {
  r = Math.min(r, w/2, h/2);
  if (r <= 0) return [[x,y],[x+w,y],[x+w,y+h],[x,y+h]];
  var pts = [], n = 12;
  var corners = [
    {cx:x+w-r, cy:y+r,   a0:-Math.PI/2, a1:0},
    {cx:x+w-r, cy:y+h-r, a0:0,          a1:Math.PI/2},
    {cx:x+r,   cy:y+h-r, a0:Math.PI/2,  a1:Math.PI},
    {cx:x+r,   cy:y+r,   a0:Math.PI,    a1:3*Math.PI/2}
  ];
  for (var ci=0; ci<4; ci++) {
    var c=corners[ci];
    for (var i=0;i<=n;i++){
      var a=c.a0+(c.a1-c.a0)*i/n;
      pts.push([c.cx+r*Math.cos(a), c.cy+r*Math.sin(a)]);
    }
  }
  return pts;
}

/* ── Compass position helper (shared by preview + export) ── */
function _compassLayout(wMm, hMm) {
  var sz = Math.min(wMm, hMm) * 0.12 * S.compassSize;
  var backerPad = 0.25;
  var bSz = sz * (1 + backerPad), bR = bSz * 0.12;
  var frameMm = S.frameThickness > 0 ? Math.max(0.3, Math.min(wMm, hMm) * S.frameThickness) : 0;
  var margin;
  if (S.compassMerge && frameMm > 0) {
    margin = frameMm - bSz * 0.15;
  } else {
    margin = sz * 0.3 + frameMm; // push inward past the frame border
  }
  var cx, cy;
  if (S.compassCorner === 'tl') { cx = margin + bSz/2; cy = margin + bSz/2; }
  else if (S.compassCorner === 'tr') { cx = wMm - margin - bSz/2; cy = margin + bSz/2; }
  else if (S.compassCorner === 'bl') { cx = margin + bSz/2; cy = hMm - margin - bSz/2; }
  else { cx = wMm - margin - bSz/2; cy = hMm - margin - bSz/2; }
  return {sz:sz, bSz:bSz, bR:bR, cx:cx, cy:cy, scale:sz/458};
}

/* ── Title position helper ── */
function _titleLayout(wMm, hMm) {
  var title = $('titleInput') ? $('titleInput').value.trim() : '';
  if (!title) return null;
  var tSz = Math.min(wMm, hMm) * 0.045 * S.titleSzMult;
  var lineGap = 1.3;
  var ox = wMm * S.titleDx / 100, oy = hMm * S.titleDy / 100;
  var totalTextH = tSz * lineGap;
  var baseY = hMm - totalTextH - tSz * 0.4 + oy;
  var baseX = tSz * 0.5 + ox;
  var strokeW = tSz * 0.35;
  // Estimate text width (approx 0.55 * fontSize per char for most fonts)
  var estW = title.length * tSz * 0.55;
  return {title:title, tSz:tSz, baseX:baseX, baseY:baseY, strokeW:strokeW, estW:estW, y1:baseY + tSz * 0.9};
}

function compassSvgExport(wMm, hMm) {
  if (S.compassCorner === 'off') return '';
  var L = _compassLayout(wMm, hMm);
  var out = '';
  // When compass is separated (not merged with frame), add the backer as a cut square
  if (!S.compassMerge) {
    var bx = (L.cx - L.bSz/2).toFixed(2);
    var by = (L.cy - L.bSz/2).toFixed(2);
    var bs = L.bSz.toFixed(2);
    var br = L.bR.toFixed(2);
    out += '<rect x="'+bx+'" y="'+by+'" width="'+bs+'" height="'+bs+'" rx="'+br+'" ry="'+br+'" fill="none" stroke="#FF0000" stroke-width="0.1"/>\n';
  }
  // Compass engrave paths (centered within backer area)
  var tx = L.cx - L.sz/2, ty = L.cy - L.sz/2;
  out += '<g transform="translate('+tx.toFixed(1)+','+ty.toFixed(1)+') scale('+L.scale.toFixed(6)+')" fill="#000000">'+COMPASS_SVG+'</g>\n';
  return out;
}

function titleSvgExport(wMm, hMm) {
  var L = _titleLayout(wMm, hMm);
  if (!L) return '';
  var strokeW = L.strokeW.toFixed(1);
  var strokeAttr = ' stroke="#d8d2c0" stroke-width="'+strokeW+'" stroke-linejoin="round" paint-order="stroke"';
  var esc = function(t) { return t.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); };
  var out = '';
  // Backer text (stroke behind)
  out += '<text x="'+L.baseX.toFixed(1)+'" y="'+L.y1.toFixed(1)+'" font-family="'+S.titleFont+'" font-size="'+L.tSz.toFixed(1)+'" font-weight="800" fill="#d8d2c0"'+strokeAttr+'>'+esc(L.title)+'</text>\n';
  // Foreground text
  out += '<text x="'+L.baseX.toFixed(1)+'" y="'+L.y1.toFixed(1)+'" font-family="'+S.titleFont+'" font-size="'+L.tSz.toFixed(1)+'" font-weight="800" fill="#000000">'+esc(L.title)+'</text>\n';
  return out;
}

function toggleRoads(on) {
  S.roadsVisible = on;
  $('roadControls').style.display = on ? 'block' : 'none';
  if (!fastRedrawOverlays()) redrawPreview();
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  GEOCODING                                                   ║
   ╚════════════════════════════════════════════════════════════════╝ */

async function searchAddress() {
  const q = $('addressInput').value.trim();
  if (!q) return;
  $('searchStatus').textContent = 'Searching…';
  $('searchBtn').disabled = true;
  try {
    const resp = await fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&q=' + encodeURIComponent(q));
    const data = await resp.json();
    if (data.length) {
      const r = data[0];
      S.map.flyTo({ center: [parseFloat(r.lon), parseFloat(r.lat)], zoom: S.zoom, duration: 1200 });
      S.map.once('moveend', function() { S.map.resize(); });
      $('searchStatus').textContent = '✓ ' + r.display_name.split(',').slice(0,3).join(',');
    } else {
      $('searchStatus').textContent = 'No results found.';
    }
  } catch(e) {
    $('searchStatus').textContent = 'Search error. Try again.';
  }
  $('searchBtn').disabled = false;
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  PREVIEW RENDERING                                           ║
   ╚════════════════════════════════════════════════════════════════╝ */

function updatePreview() {
  const frame = $('boardFrame');
  const preview = $('plaquePreview');
  const wMm = getWidthMm(), hMm = getHeightMm();
  const ratio = wMm / hMm;

  // Use full viewport height, maximize width within the frame
  let availW = frame.clientWidth - 10;
  let availH = window.innerHeight - 40;
  if (availW < 100) availW = 400;
  if (availH < 100) availH = 500;
  let pw, ph;
  if (availW / availH > ratio) { ph = availH; pw = ph * ratio; }
  else { pw = availW; ph = pw / ratio; }
  if (pw < 50) { pw = 300; ph = pw / ratio; }

  preview.style.width = pw + 'px';
  preview.style.height = ph + 'px';

  const scale = pw / wMm; // px per mm

  // Corner radius
  const crPx = 0;
  preview.style.borderRadius = '0';

  // Map fills entire plaque
  const mapWrap = $('mapWrap');
  mapWrap.style.width = pw + 'px';
  mapWrap.style.height = ph + 'px';
  mapWrap.style.left = '0';
  mapWrap.style.top = '0';
  mapWrap.style.borderRadius = '0';

  const mapEl = $('map');
  mapEl.style.width = pw + 'px';
  mapEl.style.height = ph + 'px';

  // SVG overlay (no pin)
  const ov = $('previewOverlay');
  if (ov) {
    ov.setAttribute('viewBox', '0 0 ' + pw + ' ' + ph);
    ov.innerHTML = '';
  }

  // Resize map
  if (S.map) { setTimeout(function() { S.map.resize(); }, 50); }
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  GPX ROUTE                                                   ║
   ╚════════════════════════════════════════════════════════════════╝ */

function handleGPX(input) {
  var file = input.files && input.files[0];
  if (!file) return;
  $('gpxStatus').textContent = 'Reading…';
  var reader = new FileReader();
  reader.onload = function(e) {
    try {
      var parser = new DOMParser();
      var doc = parser.parseFromString(e.target.result, 'application/xml');

      // Check for parse errors
      if (doc.querySelector('parsererror')) throw new Error('Invalid XML');

      // Extract coords from <trkpt> (track points) and <rtept> (route points)
      var coords = [];
      var trkpts = doc.querySelectorAll('trkpt');
      if (trkpts.length) {
        trkpts.forEach(function(pt) {
          var lat = parseFloat(pt.getAttribute('lat'));
          var lon = parseFloat(pt.getAttribute('lon'));
          if (!isNaN(lat) && !isNaN(lon)) coords.push([lon, lat]);
        });
      }
      // Also try <rtept> if no track points
      if (!coords.length) {
        var rtepts = doc.querySelectorAll('rtept');
        rtepts.forEach(function(pt) {
          var lat = parseFloat(pt.getAttribute('lat'));
          var lon = parseFloat(pt.getAttribute('lon'));
          if (!isNaN(lat) && !isNaN(lon)) coords.push([lon, lat]);
        });
      }
      // Also try <wpt> as last resort
      if (!coords.length) {
        var wpts = doc.querySelectorAll('wpt');
        wpts.forEach(function(pt) {
          var lat = parseFloat(pt.getAttribute('lat'));
          var lon = parseFloat(pt.getAttribute('lon'));
          if (!isNaN(lat) && !isNaN(lon)) coords.push([lon, lat]);
        });
      }

      if (coords.length < 2) throw new Error('No route data found in GPX file');

      S.gpxCoords = coords;
      $('gpxStatus').textContent = '✓ ' + coords.length + ' points loaded — ' + file.name;
      $('gpxClearBtn').style.display = 'block';
      $('gpxRouteControls').style.display = 'block';
      $('gpxLabel').innerHTML = '📂 Replace .gpx<input type="file" accept=".gpx" id="gpxInput" style="display:none;" onchange="handleGPX(this)">';

      addGPXLayer();

      // Auto-fit map to GPX bounds
      if (S.map && coords.length > 1) {
        var bounds = coords.reduce(function(b, c) {
          return [[Math.min(b[0][0], c[0]), Math.min(b[0][1], c[1])],
                  [Math.max(b[1][0], c[0]), Math.max(b[1][1], c[1])]];
        }, [[coords[0][0], coords[0][1]], [coords[0][0], coords[0][1]]]);
        S.map.fitBounds(bounds, { padding: 40, duration: 1200 });
        S.map.once('moveend', function() {
          S.zoom = Math.round(S.map.getZoom() * 2) / 2;
          $('zoomSlider').value = S.zoom;
          $('zoomVal').textContent = S.zoom;
          S.map.resize();
        });
      }

    } catch(err) {
      $('gpxStatus').textContent = '✗ ' + err.message;
      S.gpxCoords = null;
    }
  };
  reader.onerror = function() { $('gpxStatus').textContent = '✗ File read error'; };
  reader.readAsText(file);
}

function addGPXLayer() {
  if (!S.map || !S.gpxCoords) return;

  // Remove existing GPX layer/source if present
  try { S.map.removeLayer('gpx-route'); } catch(e){}
  try { S.map.removeSource('gpx-route'); } catch(e){}

  S.map.addSource('gpx-route', {
    type: 'geojson',
    data: {
      type: 'Feature',
      geometry: { type: 'LineString', coordinates: S.gpxCoords }
    }
  });
  S.map.addLayer({
    id: 'gpx-route',
    type: 'line',
    source: 'gpx-route',
    paint: {
      'line-color': '#000000',
      'line-width': 3,
      'line-opacity': 0.85
    },
    layout: { 'line-cap': 'round', 'line-join': 'round' }
  });
}

function clearGPX() {
  S.gpxCoords = null;
  $('gpxStatus').textContent = '';
  $('gpxClearBtn').style.display = 'none';
  $('gpxRouteControls').style.display = 'none';
  $('gpxLabel').innerHTML = '📂 Upload .gpx<input type="file" accept=".gpx" id="gpxInput" style="display:none;" onchange="handleGPX(this)">';

  // Remove map layer
  if (S.map) {
    try { S.map.removeLayer('gpx-route'); } catch(e){}
    try { S.map.removeSource('gpx-route'); } catch(e){}
  }
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  DETAIL LEVEL                                                ║
   ╚════════════════════════════════════════════════════════════════╝ */

function setDetail(level) {
  S.detail = level;
  // Don't change MapLibre layer visibility — canvas controls what's drawn
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  ROAD THICKNESS                                              ║
   ╚════════════════════════════════════════════════════════════════╝ */

function applyRoadWidths() {
  if (!S.map || !S.map.isStyleLoaded()) return;
  var style = S.map.getStyle();
  if (!style || !style.layers) return;

  style.layers.forEach(function(layer) {
    if (layer['source-layer'] !== 'transportation' || layer.type !== 'line') return;
    var id = layer.id;
    var idL = id.toLowerCase();
    var isMain = idL.indexOf('motorway') >= 0 || idL.indexOf('trunk') >= 0 ||
                 idL.indexOf('primary') >= 0 || idL.indexOf('secondary') >= 0;
    var isSide = idL.indexOf('tertiary') >= 0 || idL.indexOf('minor') >= 0 ||
                 idL.indexOf('service') >= 0 || idL.indexOf('track') >= 0 ||
                 idL.indexOf('path') >= 0 || idL.indexOf('residential') >= 0 ||
                 idL.indexOf('street') >= 0 || idL.indexOf('pedestrian') >= 0;
    if (!isMain && !isSide) return; // skip unknown layers

    var m = isMain ? S.mainRoadWidth : S.sideRoadWidth;
    try {
      if (isMain) {
        S.map.setPaintProperty(id, 'line-width', ['interpolate',['linear'],['zoom'], 5,0.3*m, 8,0.5*m, 12,1.8*m, 16,4.5*m]);
      } else {
        S.map.setPaintProperty(id, 'line-width', ['interpolate',['linear'],['zoom'], 5,0.1*m, 8,0.15*m, 12,0.5*m, 14,0.7*m, 16,1.8*m]);
      }
    } catch(e) {}
  });
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  SEGMENT CONTROL HELPER                                      ║
   ╚════════════════════════════════════════════════════════════════╝ */

function initSeg(containerId, callback) {
  const el = $(containerId);
  el.querySelectorAll('.sb').forEach(function(btn) {
    btn.addEventListener('click', function() {
      el.querySelectorAll('.sb').forEach(function(b){ b.classList.remove('on'); });
      btn.classList.add('on');
      callback(btn.dataset.v);
    });
  });
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  SIZE ADJUSTERS                                              ║
   ╚════════════════════════════════════════════════════════════════╝ */

function adjDim(dim, delta) {
  const key = dim === 'w' ? 'width' : 'height';
  const step = S.unit === 'in' ? 0.5 : 5;
  const min = S.unit === 'in' ? 2 : 50;
  const max = S.unit === 'in' ? 24 : 600;
  S[key] = Math.max(min, Math.min(max, S[key] + delta * step));
  $(key + 'Val').textContent = S[key] + (S.unit === 'in' ? ' in' : ' mm');
  updateDimHint();
  updatePreview();
}

function updateDimHint() {
  var el = $('dimHint');
  if (!el) return;
  const w = getWidthMm(), h = getHeightMm();
  if (S.unit === 'in') {
    el.textContent = '≈ ' + w.toFixed(1) + ' × ' + h.toFixed(1) + ' mm';
  } else {
    const wi = (w / IN_TO_MM).toFixed(2), hi = (h / IN_TO_MM).toFixed(2);
    el.textContent = '≈ ' + wi + ' × ' + hi + ' in';
  }
}

function switchUnit(u) {
  if (u === S.unit) return;
  if (u === 'mm') {
    S.width = Math.round(S.width * IN_TO_MM);
    S.height = Math.round(S.height * IN_TO_MM);
  } else {
    S.width = Math.round(S.width / IN_TO_MM * 2) / 2;
    S.height = Math.round(S.height / IN_TO_MM * 2) / 2;
    if (S.width < 2) S.width = 2;
    if (S.height < 2) S.height = 2;
  }
  S.unit = u;
  $('widthVal').textContent = S.width;
  $('heightVal').textContent = S.height;
  updateDimHint();
  updatePreview();
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  RESET                                                       ║
   ╚════════════════════════════════════════════════════════════════╝ */

function resetAll() {
  $('addressInput').value = '';
  $('searchStatus').textContent = '';
  $('zoomSlider').value = 14; S.zoom = 14; $('zoomVal').textContent = '14';
  S.detail = 'high'; setDetail('high');
  $('detailSeg').querySelectorAll('.sb').forEach(function(b){ b.classList.toggle('on', b.dataset.v==='high'); });

  // Roads reset (default OFF)
  S.roadsVisible = true;
  $('roadsSeg').querySelectorAll('.sb').forEach(function(b){ b.classList.toggle('on', b.dataset.v==='on'); });
  $('roadControls').style.display = 'block';
  $('roadControls').style.display = 'none';
  toggleRoads(false);

  // Contour reset
  S.depthLayers = 1;
  ['depthBtn1','depthBtn2','depthBtn3','depthBtn4'].forEach(function(id){ $(id).classList.toggle('on', id==='depthBtn1'); });
  setDepthLayers('1');
  S.cov2 = 50; $('cov2Val').textContent = '50%';
  S.cov3 = 25; $('cov3Val').textContent = '25%';
  S.cov4 = 12; $('cov4Val').textContent = '12%';
  S.labelsVisible = true; S.labelSzPx = 14;
  if ($('labelSzVal')) $('labelSzVal').textContent = '14 px';
  S.roadThickIdx = 2;

  S.contourLines = true;
  S.contourDensity = 2;
  if ($('contourDensityVal')) $('contourDensityVal').textContent = 'Normal';
  $('contourSeg').querySelectorAll('.sb').forEach(function(b){ b.classList.toggle('on', b.dataset.v==='on'); });

  switchUnit('in'); S.width = 9; S.height = 9;
  $('unitSeg').querySelectorAll('.sb').forEach(function(b){ b.classList.toggle('on', b.dataset.v==='in'); });
  $('widthVal').textContent = '9'; $('heightVal').textContent = '9';
  updateDimHint();
  // Compass reset
  S.compassCorner = 'tl'; S.compassSize = 1.0; S.compassMerge = false;
  $('compassSeg').querySelectorAll('.sb').forEach(function(b){ b.classList.toggle('on', b.dataset.v==='tl'); });
  $('compassMergeSeg').querySelectorAll('.sb').forEach(function(b){ b.classList.toggle('on', b.dataset.v==='off'); });

  // Frame + title reset
  frameIdx = 2; S.frameThickness = FRAME_SIZES[frameIdx]; $('frameVal').textContent = FRAME_LEVELS[frameIdx];
  S.titleText = ''; S.titleSzMult = 1.0; S.titleDx = 0; S.titleDy = 0;
  S.titleFont = "'Great Vibes',cursive";
  if ($('titleInput')) $('titleInput').value = '';
  if ($('titleFontSelect')) { $('titleFontSelect').value = "'Great Vibes',cursive"; $('titleFontSelect').style.fontFamily = "'Great Vibes',cursive"; }

  clearGPX();
  S.gpxRouteWidth = 0.6; $('gpxWidthSlider').value = 0.6; $('gpxWidthVal').textContent = '0.6 mm';
  clearElevPreview();
  $('preGenControls').style.display = 'block';
  $('postGenControls').style.display = 'none';
  applyRoadWidths();
  if (S.map) S.map.flyTo({ center:[-97,38], zoom:3, duration:800 });
  updatePreview();
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  CLIPPER HELPERS                                             ║
   ╚════════════════════════════════════════════════════════════════╝ */

function hasClipper() {
  try { return typeof ClipperLib !== 'undefined' && typeof ClipperLib.Clipper === 'function'; } catch(e) { return false; }
}

function toCP(pts) { return pts.map(function(p){ return { X: Math.round(p[0]*CS), Y: Math.round(p[1]*CS) }; }); }
function fromCP(path) { return path.map(function(p){ return [p.X/CS, p.Y/CS]; }); }

function clipperUnion(pathSets) {
  if (!hasClipper()) return [];
  var subject = [];
  pathSets.forEach(function(ps){ ps.forEach(function(p){ if(p.length>2) subject.push(toCP(p)); }); });
  if (!subject.length) return [];
  var cpr = new ClipperLib.Clipper();
  var simplified = ClipperLib.Clipper.SimplifyPolygons(subject, ClipperLib.PolyFillType.pftNonZero);
  cpr.AddPaths(simplified, ClipperLib.PolyType.ptSubject, true);
  var sol = new ClipperLib.Paths();
  cpr.Execute(ClipperLib.ClipType.ctUnion, sol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
  return ClipperLib.Clipper.CleanPolygons(sol, 0.1 * CS);
}

function clipperIntersect(subjectPaths, clipPoly) {
  if (!hasClipper() || !subjectPaths.length) return [];
  var cpr = new ClipperLib.Clipper();
  cpr.AddPaths(subjectPaths, ClipperLib.PolyType.ptSubject, true);
  cpr.AddPath(toCP(clipPoly), ClipperLib.PolyType.ptClip, true);
  var sol = new ClipperLib.Paths();
  cpr.Execute(ClipperLib.ClipType.ctIntersection, sol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
  return sol;
}

function offsetLine(coords, width) {
  if (!hasClipper() || coords.length < 2) return null;
  var co = new ClipperLib.ClipperOffset(2, 0.25 * CS);
  co.AddPath(toCP(coords), ClipperLib.JoinType.jtRound, ClipperLib.EndType.etOpenRound);
  var sol = new ClipperLib.Paths();
  co.Execute(sol, width * CS / 2);
  return sol.length ? sol : null;
}

function pathsToD(paths) {
  return paths.map(function(p) {
    var pts = (p[0] && typeof p[0].X !== 'undefined') ? fromCP(p) : p;
    if (pts.length < 2) return '';
    var d = 'M' + pts[0][0].toFixed(3) + ',' + pts[0][1].toFixed(3);
    for (var i = 1; i < pts.length; i++) d += ' L' + pts[i][0].toFixed(3) + ',' + pts[i][1].toFixed(3);
    return d + ' Z';
  }).filter(Boolean).join(' ');
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  BEZIER FLATTENING                                           ║
   ╚════════════════════════════════════════════════════════════════╝ */

function _splitCubic(x0,y0,x1,y1,x2,y2,x3,y3,tol,pts){
  var dx=x3-x0, dy=y3-y0, l2=dx*dx+dy*dy;
  if(l2<0.001){pts.push([x3,y3]);return;}
  var d1=Math.abs((x1-x0)*dy-(y1-y0)*dx);
  var d2=Math.abs((x2-x0)*dy-(y2-y0)*dx);
  if((d1+d2)*(d1+d2)<=tol*tol*4*l2){pts.push([x3,y3]);return;}
  var ax=(x0+x1)/2,ay=(y0+y1)/2,bx=(x1+x2)/2,by=(y1+y2)/2;
  var cx2=(x2+x3)/2,cy2=(y2+y3)/2,dx2=(ax+bx)/2,dy2=(ay+by)/2;
  var ex=(bx+cx2)/2,ey=(by+cy2)/2,mx=(dx2+ex)/2,my=(dy2+ey)/2;
  _splitCubic(x0,y0,ax,ay,dx2,dy2,mx,my,tol,pts);
  _splitCubic(mx,my,ex,ey,cx2,cy2,x3,y3,tol,pts);
}

function _splitQuad(x0,y0,x1,y1,x2,y2,tol,pts){
  _splitCubic(x0,y0, x0+(x1-x0)*2/3,y0+(y1-y0)*2/3, x2+(x1-x2)*2/3,y2+(y1-y2)*2/3, x2,y2, tol, pts);
}

function flattenCmds(cmds, tol) {
  var out=[], cur=null, px=0, py=0;
  for (var i=0;i<cmds.length;i++){
    var c = cmds[i];
    switch(c.type){
      case 'M': if(cur&&cur.length>1) out.push(cur); cur=[[c.x,c.y]]; px=c.x; py=c.y; break;
      case 'L': if(cur) cur.push([c.x,c.y]); px=c.x; py=c.y; break;
      case 'C': if(cur) _splitCubic(px,py,c.x1,c.y1,c.x2,c.y2,c.x,c.y,tol,cur); px=c.x; py=c.y; break;
      case 'Q': if(cur) _splitQuad(px,py,c.x1,c.y1,c.x,c.y,tol,cur); px=c.x; py=c.y; break;
      case 'Z': if(cur&&cur.length>1) out.push(cur); cur=null; break;
    }
  }
  if(cur&&cur.length>1) out.push(cur);
  return out;
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  SVG EXPORT                                                  ║
   ╚════════════════════════════════════════════════════════════════╝ */

/* ── Title → path export using opentype.js + ClipperLib ── */
async function titlePathExport(wMm, hMm) {
  var TL = _titleLayout(wMm, hMm);
  if (!TL || !hasClipper()) return null;
  if (typeof opentype === 'undefined') return null;
  var font = await loadFont(S.titleFont);
  if (!font) return null;
  try {
    var path = font.getPath(TL.title, TL.baseX, TL.y1, TL.tSz);
    var contours = flattenCmds(path.commands, 0.03);
    if (!contours.length) return null;
    // Union all glyph contours with pftNonZero (handles overlapping)
    var cpPaths = contours.map(function(c){ return toCP(c); });
    var cpr2 = new ClipperLib.Clipper();
    var simplified = ClipperLib.Clipper.SimplifyPolygons(cpPaths, ClipperLib.PolyFillType.pftNonZero);
    cpr2.AddPaths(simplified, ClipperLib.PolyType.ptSubject, true);
    var unionResult = new ClipperLib.Paths();
    cpr2.Execute(ClipperLib.ClipType.ctUnion, unionResult, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
    unionResult = ClipperLib.Clipper.CleanPolygons(unionResult, 0.05 * CS);
    // Offset outward for backer
    var co2 = new ClipperLib.ClipperOffset(2, 0.25 * CS);
    co2.AddPaths(unionResult, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
    var backerResult = new ClipperLib.Paths();
    co2.Execute(backerResult, TL.strokeW * CS);
    backerResult = ClipperLib.Clipper.CleanPolygons(backerResult, 0.05 * CS);
    return {
      engraveCP: unionResult,
      backerCP: backerResult,
      engraveD: pathsToD(unionResult),
      backerD: pathsToD(backerResult)
    };
  } catch(e) { console.warn('Title path conversion failed:', e); return null; }
}

/* ── Labels → path export: returns {engraveSvg, backerCP} ── */
async function labelsPathExport(wMm, hMm, proj) {  if (!S.labelsVisible || !S.map || !hasClipper()) return null;
  if (typeof opentype === 'undefined') return null;
  var labelFont = _fontCache['__label'] || null;
  if (!labelFont) {
    try {
      var buf = await (await fetch(LABEL_FONT_URL)).arrayBuffer();
      labelFont = opentype.parse(buf);
      _fontCache['__label'] = labelFont;
    } catch(e) { return null; }
  }
  var labelFeatures = [];
  try {
    var style = S.map.getStyle();
    var ids = style.layers.filter(function(l) {
      if (l.type !== 'symbol') return false;
      var sl = l['source-layer'] || '';
      return sl.indexOf('place') >= 0 || sl.indexOf('poi') >= 0 || sl.indexOf('transportation_name') >= 0;
    }).map(function(l) { return l.id; });
    // If no matching source-layers, try ALL symbol layers
    if (!ids.length) {
      ids = style.layers.filter(function(l) { return l.type === 'symbol'; }).map(function(l) { return l.id; });
    }
    if (ids.length) labelFeatures = S.map.queryRenderedFeatures(undefined, { layers: ids });
  } catch(e) {}
  if (!labelFeatures.length) return null;

  // Convert px (on preview canvas) to mm (SVG output)
  var previewH = _cachedMapCanvasSize ? _cachedMapCanvasSize.h : 700;
  var fontSize = S.labelSzPx * (hMm / previewH);
  var padX = fontSize * 0.4, padY = fontSize * 0.3;
  var seen = {}, allTextCP = [], allBackerCP = [];

  labelFeatures.forEach(function(f) {
    var name = f.properties.name || f.properties['name:en'] || '';
    if (!name || name.length > 30) return;
    var coords = f.geometry.type === 'Point' ? f.geometry.coordinates : null;
    if (!coords) return;
    var key = name + '|' + coords[0].toFixed(3);
    if (seen[key]) return; seen[key] = true;
    var mm = proj({lng: coords[0], lat: coords[1]});
    if (mm[0] < 0 || mm[0] > wMm || mm[1] < 0 || mm[1] > hMm) return;
    try {
      var pathM = labelFont.getPath(name, 0, 0, fontSize);
      var bbox = pathM.getBoundingBox();
      var textW = bbox.x2 - bbox.x1;
      var cx = mm[0] - textW / 2, cy = mm[1] + fontSize * 0.35;
      var path2 = labelFont.getPath(name, cx, cy, fontSize);
      var contours = flattenCmds(path2.commands, 0.02);
      if (!contours.length) return;
      var cpPaths = contours.map(function(c) { return toCP(c); });
      var simplified = ClipperLib.Clipper.SimplifyPolygons(cpPaths, ClipperLib.PolyFillType.pftNonZero);
      for (var si2 = 0; si2 < simplified.length; si2++) allTextCP.push(simplified[si2]);
      // Backer rectangle
      var bx = cx - padX, by = cy - fontSize - padY;
      allBackerCP.push(toCP([[bx,by],[bx+textW+padX*2,by],[bx+textW+padX*2,by+fontSize+padY*2],[bx,by+fontSize+padY*2]]));
    } catch(e) {}
  });
  if (!allTextCP.length) return null;
  var cprT = new ClipperLib.Clipper();
  cprT.AddPaths(allTextCP, ClipperLib.PolyType.ptSubject, true);
  var textUnion = new ClipperLib.Paths();
  cprT.Execute(ClipperLib.ClipType.ctUnion, textUnion, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
  textUnion = ClipperLib.Clipper.CleanPolygons(textUnion, 0.02 * CS);
  var cprB = new ClipperLib.Clipper();
  cprB.AddPaths(allBackerCP, ClipperLib.PolyType.ptSubject, true);
  var backerUnion = new ClipperLib.Paths();
  cprB.Execute(ClipperLib.ClipType.ctUnion, backerUnion, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
  return {
    engraveSvg: textUnion.length ? '<path d="' + pathsToD(textUnion) + '" fill="#000000" fill-rule="evenodd"/>' : '',
    backerCP: backerUnion,
    textCP: textUnion
  };
}


async function downloadSVG() {
  var dlBtn = $('dlBtn');
  dlBtn.disabled = true;
  dlBtn.textContent = 'Generating…';

  try {
    if (!S.map) throw new Error('Map not loaded');

    var wMm = getWidthMm(), hMm = getHeightMm();
    var cornerMm = 0;

    // Map fills entire plaque — full bleed
    var mapCx = wMm / 2;
    var mapCy = hMm / 2;

    // Build projector — map canvas fills plaque
    var map = S.map;
    var center = map.getCenter();
    var centerPx = map.project(center);
    var canvas = map.getCanvas();
    var mmPerPxX = wMm / canvas.clientWidth;
    var mmPerPxY = hMm / canvas.clientHeight;

    function proj(lngLat) {
      var px = map.project(lngLat);
      return [mapCx + (px.x - centerPx.x) * mmPerPxX, mapCy + (px.y - centerPx.y) * mmPerPxY];
    }

    // ── Extract roads ──
    // ── Extract roads — find transportation layers dynamically from loaded style ──
    var roadFeatures = [];
    try {
      var allLayers = map.getStyle().layers;
      var transportLayers = allLayers.filter(function(l) {
        return l['source-layer'] === 'transportation' && (l.type === 'line' || l.type === 'fill');
      }).map(function(l) { return l.id; });
      if (transportLayers.length) {
        roadFeatures = map.queryRenderedFeatures(undefined, { layers: transportLayers });
      }
    } catch(e) { console.warn('Road extraction error:', e); }

    var roadPolys = [];
    var exportMainClasses = ['motorway','trunk'];
    var exportMedClasses = ['motorway','trunk','primary','secondary','tertiary'];
    roadFeatures.forEach(function(f) {
      var cls = f.properties.class || 'minor';
      // Filter by detail level
      if (S.detail === 'low' && exportMainClasses.indexOf(cls) < 0) return;
      if (S.detail === 'med' && exportMedClasses.indexOf(cls) < 0) return;
      var w = (ROAD_WIDTHS[cls] || 0.3) * getDetailScale();
      // Apply road thickness multiplier from sliders
      var isMain = cls === 'motorway' || cls === 'trunk' || cls === 'primary' || cls === 'secondary';
      w *= isMain ? S.mainRoadWidth : S.sideRoadWidth;
      var lines = [];
      if (f.geometry.type === 'LineString') lines.push(f.geometry.coordinates);
      else if (f.geometry.type === 'MultiLineString') lines = f.geometry.coordinates;
      lines.forEach(function(coords) {
        var mmCoords = coords.map(function(c){ return proj({lng:c[0],lat:c[1]}); });
        var polys = offsetLine(mmCoords, w);
        if (polys) polys.forEach(function(p){ roadPolys.push(p); });
      });
    });

    // Union roads
    var roadUnion = [];
    if (roadPolys.length && hasClipper()) {
      var cpr = new ClipperLib.Clipper();
      var simplified = ClipperLib.Clipper.SimplifyPolygons(roadPolys, ClipperLib.PolyFillType.pftNonZero);
      cpr.AddPaths(simplified, ClipperLib.PolyType.ptSubject, true);
      var sol = new ClipperLib.Paths();
      cpr.Execute(ClipperLib.ClipType.ctUnion, sol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
      roadUnion = ClipperLib.Clipper.CleanPolygons(sol, 0.05 * CS);
    }

    // Clip roads to full plaque rectangle (inset 0.3mm for clean edges)
    var clipInset = 0.3;
    var clipPoly = [
      [clipInset, clipInset],
      [wMm - clipInset, clipInset],
      [wMm - clipInset, hMm - clipInset],
      [clipInset, hMm - clipInset]
    ];
    var roadClipped = clipperIntersect(roadUnion, clipPoly);

    // ── Extract water ──
    // ── Extract water — find water layers dynamically ──
    var waterFeatures = [];
    try {
      var allLayers2 = map.getStyle().layers;
      var waterLayers = allLayers2.filter(function(l) {
        return l['source-layer'] === 'water' && l.type === 'fill';
      }).map(function(l) { return l.id; });
      if (waterLayers.length) {
        waterFeatures = map.queryRenderedFeatures(undefined, { layers: waterLayers });
      }
    } catch(e) {}

    var waterPolys = [];
    waterFeatures.forEach(function(f) {
      var polys = [];
      if (f.geometry.type === 'Polygon') polys.push(f.geometry.coordinates);
      else if (f.geometry.type === 'MultiPolygon') polys = f.geometry.coordinates;
      polys.forEach(function(rings) {
        rings.forEach(function(ring) {
          var mmRing = ring.map(function(c){ return proj({lng:c[0],lat:c[1]}); });
          if (mmRing.length > 2) waterPolys.push(toCP(mmRing));
        });
      });
    });

    var waterUnion = [];
    if (waterPolys.length && hasClipper()) {
      var wcpr = new ClipperLib.Clipper();
      wcpr.AddPaths(waterPolys, ClipperLib.PolyType.ptSubject, true);
      var wsol = new ClipperLib.Paths();
      wcpr.Execute(ClipperLib.ClipType.ctUnion, wsol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
      waterUnion = wsol;
    }
    var waterClipped = waterUnion.length ? clipperIntersect(waterUnion, clipPoly) : [];

    // ── Waterway lines ──
    var waterwayFeatures = [];
    if (S.detail !== 'low') {
      try {
        var allLayers3 = map.getStyle().layers;
        var wwLayers = allLayers3.filter(function(l) {
          return l['source-layer'] === 'waterway' && (l.type === 'line' || l.type === 'fill');
        }).map(function(l) { return l.id; });
        if (wwLayers.length) {
          waterwayFeatures = map.queryRenderedFeatures(undefined, { layers: wwLayers });
        }
      } catch(e) {}
    }
    var waterwayPolys = [];
    waterwayFeatures.forEach(function(f) {
      var lines = [];
      if (f.geometry.type === 'LineString') lines.push(f.geometry.coordinates);
      else if (f.geometry.type === 'MultiLineString') lines = f.geometry.coordinates;
      lines.forEach(function(coords) {
        var mmCoords = coords.map(function(c){ return proj({lng:c[0],lat:c[1]}); });
        var polys = offsetLine(mmCoords, 0.8);
        if (polys) polys.forEach(function(p){ waterwayPolys.push(p); });
      });
    });
    if (waterwayPolys.length) {
      var allWater = waterClipped.concat(waterwayPolys);
      if (hasClipper()) {
        var wwcpr = new ClipperLib.Clipper();
        wwcpr.AddPaths(allWater, ClipperLib.PolyType.ptSubject, true);
        var wwsol = new ClipperLib.Paths();
        wwcpr.Execute(ClipperLib.ClipType.ctUnion, wwsol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
        waterClipped = clipperIntersect(wwsol, clipPoly);
      }
    }



    // ── GPX route ──
    var gpxClipped = [];
    if (S.gpxCoords && S.gpxCoords.length >= 2 && hasClipper()) {
      var gpxMm = S.gpxCoords.map(function(c){ return proj({lng:c[0],lat:c[1]}); });
      var gpxPolys = offsetLine(gpxMm, S.gpxRouteWidth);
      if (gpxPolys && gpxPolys.length) {
        var gpxCpr = new ClipperLib.Clipper();
        gpxCpr.AddPaths(gpxPolys, ClipperLib.PolyType.ptSubject, true);
        var gpxSol = new ClipperLib.Paths();
        gpxCpr.Execute(ClipperLib.ClipType.ctUnion, gpxSol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
        gpxClipped = clipperIntersect(gpxSol, clipPoly);
      }
    }

    // ── Elevation layers ──
    dlBtn.textContent = 'Loading terrain\u2026';
    var elevData = await new Promise(function(resolve){
      if (_elevCache) { resolve(_elevCache); return; }
      fetchElevationGrid(map, 500, resolve);
    });

    var N = S.depthLayers;
    var range = elevData.maxEle - elevData.minEle;
    if (range < 1) range = 1;

    // Generate terrain polygons for layers 2+ (grid coords)
    // Subsample grid for fast polygon generation
    var exportGrid = subsampleGrid(elevData, 150);
    dlBtn.textContent = 'Building layers\u2026';
    var terrainLayerPolys = []; // each: {cutPolys, scorePolys} in mm
    // Use coverage-based percentile thresholds matching preview
    var exportThresholds = [];
    if (elevData._thresholds && elevData._thresholds.length === N-1) {
      exportThresholds = elevData._thresholds;
    } else {
      var sorted2 = Array.from(elevData.grid).sort(function(a,b){return a-b;});
      var pctls2 = [];
      if (N >= 2) pctls2.push(1 - S.cov2/100);
      if (N >= 3) pctls2.push(1 - S.cov3/100);
      if (N >= 4) pctls2.push(1 - S.cov4/100);
      pctls2.forEach(function(p){
        var eidx = Math.floor(p * sorted2.length);
        exportThresholds.push(sorted2[Math.min(eidx, sorted2.length-1)]);
      });
    }

    for (var li = 1; li < N; li++) {
      var threshold = exportThresholds[li-1];
      var gridPolys = elevationToPolygons(exportGrid, threshold);
      // Convert grid coords to mm
      var mmPolys = gridPolys.map(function(poly) {
        return poly.map(function(pt) {
          return [pt[0] / exportGrid.width * wMm, pt[1] / exportGrid.height * hMm];
        });
      });
      // Clip to plaque
      var clippedPaths = [];
      if (mmPolys.length && hasClipper()) {
        var cpPaths = mmPolys.map(function(p){ return toCP(p); });
        clippedPaths = clipperIntersect(cpPaths, clipPoly);
      }
      terrainLayerPolys.push({cut: clippedPaths, score: []});
    }

    // Water polygons for cutout (needed before contour clipping)
    var waterCutPaths = [];
    if (true && waterClipped.length) {
      waterCutPaths = waterClipped;
    }

    // Generate contour lines via marching squares (line segments, not polygons)
    var contourScoreD = '';
    if (S.contourLines) {
      var contourSteps = CONTOUR_STEPS[S.contourDensity] || 8;
      var grid = elevData.grid, gw = elevData.width, gh = elevData.height;
      var contourD = '';
      for (var ci = 1; ci < contourSteps; ci++) {
        var cThresh = elevData.minEle + (ci / contourSteps) * range;
        // Skip thresholds too close to layer boundaries (already physical cuts)
        var tooClose = false;
        for (var ei = 0; ei < exportThresholds.length; ei++) {
          if (Math.abs(cThresh - exportThresholds[ei]) < range * 0.03) { tooClose = true; break; }
        }
        if (tooClose) continue;
        // Marching squares → SVG line segments
        for (var gy = 0; gy < gh-1; gy++) {
          for (var gx = 0; gx < gw-1; gx++) {
            var vTL=grid[gy*gw+gx], vTR=grid[gy*gw+gx+1];
            var vBR=grid[(gy+1)*gw+gx+1], vBL=grid[(gy+1)*gw+gx];
            var tl=vTL>=cThresh?1:0, tr=vTR>=cThresh?1:0;
            var br=vBR>=cThresh?1:0, bl=vBL>=cThresh?1:0;
            var mc=tl*8+tr*4+br*2+bl;
            if(mc===0||mc===15)continue;
            var tt4;
            tt4=(cThresh-vTL)/(vTR-vTL);if(tt4<0)tt4=0;if(tt4>1)tt4=1;var top2=[(gx+tt4)/gw*wMm,gy/gh*hMm];
            tt4=(cThresh-vTR)/(vBR-vTR);if(tt4<0)tt4=0;if(tt4>1)tt4=1;var right2=[(gx+1)/gw*wMm,(gy+tt4)/gh*hMm];
            tt4=(cThresh-vBL)/(vBR-vBL);if(tt4<0)tt4=0;if(tt4>1)tt4=1;var bottom2=[(gx+tt4)/gw*wMm,(gy+1)/gh*hMm];
            tt4=(cThresh-vTL)/(vBL-vTL);if(tt4<0)tt4=0;if(tt4>1)tt4=1;var left2=[gx/gw*wMm,(gy+tt4)/gh*hMm];
            var segs=[];
            if(mc===1||mc===14){segs.push(left2,bottom2);}
            else if(mc===2||mc===13){segs.push(bottom2,right2);}
            else if(mc===3||mc===12){segs.push(left2,right2);}
            else if(mc===4||mc===11){segs.push(top2,right2);}
            else if(mc===6||mc===9){segs.push(top2,bottom2);}
            else if(mc===7||mc===8){segs.push(top2,left2);}
            else if(mc===5){segs.push(left2,top2,bottom2,right2);}
            else if(mc===10){segs.push(top2,right2,left2,bottom2);}
            for(var si=0;si<segs.length;si+=2){
              contourD+='M'+segs[si][0].toFixed(2)+','+segs[si][1].toFixed(2)+
                'L'+segs[si+1][0].toFixed(2)+','+segs[si+1][1].toFixed(2)+' ';
            }
          }
        }
      }
      contourScoreD = contourD;
    }

    // ── Compute visible surfaces per layer ──
    // Each layer's visible surface = its area minus the layer above it
    var visibleSurfaces = []; // index matches terrainLayerPolys
    for (var vi = 0; vi < terrainLayerPolys.length; vi++) {
      var layerPaths = terrainLayerPolys[vi].cut;
      if (vi + 1 < terrainLayerPolys.length) {
        var nextPaths = terrainLayerPolys[vi + 1].cut;
        if (nextPaths.length && layerPaths.length && hasClipper()) {
          var visCpr = new ClipperLib.Clipper();
          visCpr.AddPaths(layerPaths, ClipperLib.PolyType.ptSubject, true);
          visCpr.AddPaths(nextPaths, ClipperLib.PolyType.ptClip, true);
          var visSol = new ClipperLib.Paths();
          visCpr.Execute(ClipperLib.ClipType.ctDifference, visSol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
          visibleSurfaces.push(visSol);
        } else {
          visibleSurfaces.push(layerPaths);
        }
      } else {
        visibleSurfaces.push(layerPaths); // topmost layer: full area visible
      }
    }

    // Base/land visible surface = full plaque (or land minus water) minus lowest terrain layer above
    var baseVisible = [toCP(clipPoly)];
    if (true && waterCutPaths.length && hasClipper()) {
      var bwCpr = new ClipperLib.Clipper();
      bwCpr.AddPath(toCP(clipPoly), ClipperLib.PolyType.ptSubject, true);
      bwCpr.AddPaths(waterCutPaths, ClipperLib.PolyType.ptClip, true);
      var bwSol = new ClipperLib.Paths();
      bwCpr.Execute(ClipperLib.ClipType.ctDifference, bwSol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
      baseVisible = bwSol;
    }
    if (terrainLayerPolys.length && terrainLayerPolys[0].cut.length && hasClipper()) {
      var btCpr = new ClipperLib.Clipper();
      btCpr.AddPaths(baseVisible, ClipperLib.PolyType.ptSubject, true);
      btCpr.AddPaths(terrainLayerPolys[0].cut, ClipperLib.PolyType.ptClip, true);
      var btSol = new ClipperLib.Paths();
      btCpr.Execute(ClipperLib.ClipType.ctDifference, btSol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
      baseVisible = btSol;
    }

    // ── Pre-compute layer ownership grid (fast lookup) ──
    // Use subsampled grid for contour lines too
    var grid = exportGrid.grid, gw = exportGrid.width, gh = exportGrid.height;
    var layerGrid = new Uint8Array(gw * gh);
    for (var lgi = 0; lgi < gw * gh; lgi++) {
      var ele2 = grid[lgi];
      var band2 = 0;
      for (var lti = 0; lti < exportThresholds.length; lti++) {
        if (ele2 >= exportThresholds[lti]) band2 = lti + 1;
      }
      layerGrid[lgi] = band2;
    }

    // ── Generate contour lines via marching squares, assigned to layers ──
    dlBtn.textContent = 'Generating contours\u2026';
    var numSurfaces = 1 + terrainLayerPolys.length;
    var layerContourD2 = [];
    for (var lcdi = 0; lcdi < numSurfaces; lcdi++) layerContourD2.push('');

    // Build water mask on a canvas (fast rasterization)
    var waterMask = new Uint8Array(gw * gh);
    if (waterCutPaths.length) {
      var wmCv = document.createElement('canvas');
      wmCv.width = gw; wmCv.height = gh;
      var wmCtx = wmCv.getContext('2d');
      wmCtx.fillStyle = '#000';
      waterCutPaths.forEach(function(wp) {
        wmCtx.beginPath();
        for (var wmi = 0; wmi < wp.length; wmi++) {
          var wpx = wp[wmi].X / CS / wMm * gw;
          var wpy = wp[wmi].Y / CS / hMm * gh;
          if (wmi === 0) wmCtx.moveTo(wpx, wpy);
          else wmCtx.lineTo(wpx, wpy);
        }
        wmCtx.closePath();
        wmCtx.fill();
      });
      var wmData = wmCtx.getImageData(0, 0, gw, gh).data;
      for (var wmi2 = 0; wmi2 < gw * gh; wmi2++) {
        waterMask[wmi2] = wmData[wmi2 * 4 + 3] > 0 ? 1 : 0;
      }
    }

    if (S.contourLines) {
      var contourSteps = CONTOUR_STEPS[S.contourDensity] || 8;
      // Collect segments per layer, per contour level
      var layerContourSegs = [];
      for (var lci = 0; lci < numSurfaces; lci++) layerContourSegs.push([]);

      for (var ci = 1; ci < contourSteps; ci++) {
        var cThresh = elevData.minEle + (ci / contourSteps) * range;
        var tooClose = false;
        for (var ei = 0; ei < exportThresholds.length; ei++) {
          if (Math.abs(cThresh - exportThresholds[ei]) < range * 0.04) { tooClose = true; break; }
        }
        if (tooClose) continue;
        for (var gy = 0; gy < gh-1; gy++) {
          for (var gx = 0; gx < gw-1; gx++) {
            var vTL=grid[gy*gw+gx], vTR=grid[gy*gw+gx+1];
            var vBR=grid[(gy+1)*gw+gx+1], vBL=grid[(gy+1)*gw+gx];
            var tl=vTL>=cThresh?1:0, tr=vTR>=cThresh?1:0;
            var br=vBR>=cThresh?1:0, bl=vBL>=cThresh?1:0;
            var mc=tl*8+tr*4+br*2+bl;
            if(mc===0||mc===15)continue;
            var tt3,p1,p2;
            var tt5;
            tt5=(cThresh-vTL)/(vTR-vTL);if(tt5<0)tt5=0;if(tt5>1)tt5=1;var mTop=[(gx+tt5)/gw*wMm,gy/gh*hMm];
            tt5=(cThresh-vTR)/(vBR-vTR);if(tt5<0)tt5=0;if(tt5>1)tt5=1;var mRt=[(gx+1)/gw*wMm,(gy+tt5)/gh*hMm];
            tt5=(cThresh-vBL)/(vBR-vBL);if(tt5<0)tt5=0;if(tt5>1)tt5=1;var mBt=[(gx+tt5)/gw*wMm,(gy+1)/gh*hMm];
            tt5=(cThresh-vTL)/(vBL-vTL);if(tt5<0)tt5=0;if(tt5>1)tt5=1;var mLt=[gx/gw*wMm,(gy+tt5)/gh*hMm];
            var pairs=[];
            if(mc===1||mc===14)pairs.push([mLt,mBt]);
            else if(mc===2||mc===13)pairs.push([mBt,mRt]);
            else if(mc===3||mc===12)pairs.push([mLt,mRt]);
            else if(mc===4||mc===11)pairs.push([mTop,mRt]);
            else if(mc===6||mc===9)pairs.push([mTop,mBt]);
            else if(mc===7||mc===8)pairs.push([mTop,mLt]);
            else if(mc===5)pairs.push([mLt,mTop],[mBt,mRt]);
            else if(mc===10)pairs.push([mTop,mRt],[mLt,mBt]);
            var cellLayer = layerGrid[gy * gw + gx];
            if (cellLayer >= numSurfaces) cellLayer = numSurfaces - 1;
            if (waterMask[gy * gw + gx]) continue;
            for(var pi3=0;pi3<pairs.length;pi3++){
              layerContourSegs[cellLayer].push(pairs[pi3]);
            }
          }
        }
      }

      // Chain segments into polylines + smooth via Chaikin, output as SVG
      for (var lyr = 0; lyr < numSurfaces; lyr++) {
        var polys = chainSegments(layerContourSegs[lyr]);
        for (var pi = 0; pi < polys.length; pi++) {
          var smoothed = chaikinSmooth(polys[pi], 2);
          if (smoothed.length < 2) continue;
          var d = 'M' + smoothed[0][0].toFixed(2) + ',' + smoothed[0][1].toFixed(2);
          for (var pj = 1; pj < smoothed.length; pj++) {
            d += 'L' + smoothed[pj][0].toFixed(2) + ',' + smoothed[pj][1].toFixed(2);
          }
          layerContourD2[lyr] += d + ' ';
        }
      }
    }

    var allSurfaces = [baseVisible].concat(visibleSurfaces);

    // ── Roads + GPX go on first terrain layer only ──
    var allRoadsD = '';
    if (S.roadsVisible && roadClipped.length) {
      allRoadsD = pathsToD(roadClipped);
    }
    var allGpxD = '';
    if (gpxClipped.length) {
      allGpxD = pathsToD(gpxClipped);
    }

    // ── Build SVG pieces ──
    dlBtn.textContent = 'Assembling SVG\u2026';
    var pieces = [];

    // Pre-compute inner frame polygon for clipping terrain to frame window
    var hasFrame = S.frameThickness > 0 && hasClipper();
    var frameMm = hasFrame ? Math.max(0.3, Math.min(wMm, hMm) * S.frameThickness) : 0;
    var innerFrameCP = null;
    var innerFrameD = '';
    if (hasFrame) {
      var innerPoly = _rrPts(frameMm, frameMm, wMm - 2*frameMm, hMm - 2*frameMm, 0);
      innerFrameCP = [toCP(innerPoly)];
      innerFrameD = _rrD(frameMm, frameMm, wMm - 2*frameMm, hMm - 2*frameMm, 0);
    }

    // Helper: merge terrain with frame into ONE piece.
    // terrainStayCP = ClipperLib paths defining material that STAYS (land/terrain shape).
    // Returns cutD for the NEGATIVE SPACE = innerFrame minus terrain.
    // When cut, the terrain stays connected to the frame border = one solid piece.
    function mergeWithFrame(terrainStayCP) {
      if (!innerFrameCP) return '';
      if (!terrainStayCP || !terrainStayCP.length) return innerFrameD; // no terrain → cut entire inner area
      var cpr5 = new ClipperLib.Clipper();
      cpr5.AddPaths(innerFrameCP, ClipperLib.PolyType.ptSubject, true);
      cpr5.AddPaths(terrainStayCP, ClipperLib.PolyType.ptClip, true);
      var sol5 = new ClipperLib.Paths();
      cpr5.Execute(ClipperLib.ClipType.ctDifference, sol5, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
      return sol5.length ? pathsToD(sol5) : '';
    }

    // Base layer — plain board (deepest water fill)
    pieces.push({
      label: 'Layer 1 (Base / Water)',
      rect: true
    });

    // ── Convert title + labels to paths BEFORE building pieces ──
    dlBtn.textContent = 'Converting text\u2026';
    var titleResult = await titlePathExport(wMm, hMm);
    var labelsResult = await labelsPathExport(wMm, hMm, proj);
    var labelsSvg = labelsResult ? labelsResult.engraveSvg : '';
    var labelBackerCP = labelsResult ? labelsResult.backerCP : null;

    // Knock out roads where label backers are
    if (labelBackerCP && labelBackerCP.length && roadClipped.length) {
      var kcpr = new ClipperLib.Clipper();
      kcpr.AddPaths(roadClipped, ClipperLib.PolyType.ptSubject, true);
      kcpr.AddPaths(labelBackerCP, ClipperLib.PolyType.ptClip, true);
      var ksol = new ClipperLib.Paths();
      kcpr.Execute(ClipperLib.ClipType.ctDifference, ksol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
      roadClipped = ksol;
      allRoadsD = S.roadsVisible && roadClipped.length ? pathsToD(roadClipped) : '';
    }

    dlBtn.textContent = 'Assembling SVG\u2026';

    if (N === 1) {
      // Single terrain: land with water removed
      var landPaths2 = [];
      if (waterCutPaths.length && hasClipper()) {
        var rectP = toCP(clipPoly);
        var lcpr3 = new ClipperLib.Clipper();
        lcpr3.AddPath(rectP, ClipperLib.PolyType.ptSubject, true);
        lcpr3.AddPaths(waterCutPaths, ClipperLib.PolyType.ptClip, true);
        var lsol3 = new ClipperLib.Paths();
        lcpr3.Execute(ClipperLib.ClipType.ctDifference, lsol3, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
        landPaths2 = lsol3;
      }
      // Merge label backers into land shape
      if (labelBackerCP && labelBackerCP.length && landPaths2.length) {
        var lbcpr = new ClipperLib.Clipper();
        lbcpr.AddPaths(landPaths2, ClipperLib.PolyType.ptSubject, true);
        lbcpr.AddPaths(labelBackerCP, ClipperLib.PolyType.ptClip, true);
        var lbsol = new ClipperLib.Paths();
        lbcpr.Execute(ClipperLib.ClipType.ctUnion, lbsol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
        landPaths2 = lbsol;
      }
      pieces.push({
        label: 'Layer 2 (Land)',
        rect: true,
        cutD: hasFrame ? mergeWithFrame(landPaths2) : (landPaths2.length ? pathsToD(landPaths2) : ''),
        scoreD: layerContourD2[0],
        engraveD: allRoadsD + (allGpxD ? ' ' + allGpxD : ''),
        rawSvg: labelsSvg
      });
    } else {
      // Multi-terrain: land layer
      if (waterCutPaths.length && hasClipper()) {
        var rectP2 = toCP(clipPoly);
        var lcpr4 = new ClipperLib.Clipper();
        lcpr4.AddPath(rectP2, ClipperLib.PolyType.ptSubject, true);
        lcpr4.AddPaths(waterCutPaths, ClipperLib.PolyType.ptClip, true);
        var lsol4 = new ClipperLib.Paths();
        lcpr4.Execute(ClipperLib.ClipType.ctDifference, lsol4, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
        // Merge label backers into land shape
        if (labelBackerCP && labelBackerCP.length && lsol4.length) {
          var lbcpr2 = new ClipperLib.Clipper();
          lbcpr2.AddPaths(lsol4, ClipperLib.PolyType.ptSubject, true);
          lbcpr2.AddPaths(labelBackerCP, ClipperLib.PolyType.ptClip, true);
          var lbsol2 = new ClipperLib.Paths();
          lbcpr2.Execute(ClipperLib.ClipType.ctUnion, lbsol2, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
          lsol4 = lbsol2;
        }
        pieces.push({
          label: 'Layer 2 (Land)',
          rect: true,
          cutD: hasFrame ? mergeWithFrame(lsol4) : pathsToD(lsol4),
          scoreD: layerContourD2[0],
          engraveD: allRoadsD + (allGpxD ? ' ' + allGpxD : ''),
          rawSvg: labelsSvg
        });
      }

      // Terrain layers
      for (var ti = 0; ti < terrainLayerPolys.length; ti++) {
        var tl = terrainLayerPolys[ti];
        var isTop = (ti === terrainLayerPolys.length - 1);
        var layerNum = pieces.length + 1;
        var contIdx = ti + 1;

        var cutPaths3 = tl.cut;
        if (waterCutPaths.length && cutPaths3.length && hasClipper()) {
          var wcpr2 = new ClipperLib.Clipper();
          wcpr2.AddPaths(cutPaths3, ClipperLib.PolyType.ptSubject, true);
          wcpr2.AddPaths(waterCutPaths, ClipperLib.PolyType.ptClip, true);
          var wsol2 = new ClipperLib.Paths();
          wcpr2.Execute(ClipperLib.ClipType.ctDifference, wsol2, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
          cutPaths3 = wsol2;
        }

        pieces.push({
          label: 'Layer ' + layerNum + (isTop ? ' (Top)' : ''),
          rect: true,
          cutD: hasFrame ? mergeWithFrame(cutPaths3) : (cutPaths3.length ? pathsToD(cutPaths3) : ''),
          scoreD: layerContourD2[contIdx] || '',
          engraveD: ''
        });
      }
    }

    // ── Top layer: Frame + Title + Compass ──
    var topPiece = {label:'Layer ' + (pieces.length+1) + ' (Frame + Title)'};
    topPiece.rect = true;

    if (hasFrame) {
      var topInnerCP = innerFrameCP.slice();

      // Merge compass backer with frame
      if (S.compassMerge && S.compassCorner !== 'off') {
        var CL = _compassLayout(wMm, hMm);
        var compassPoly = _rrPts(CL.cx - CL.bSz/2, CL.cy - CL.bSz/2, CL.bSz, CL.bSz, CL.bR);
        var compassCP = [toCP(compassPoly)];
        var mcpr = new ClipperLib.Clipper();
        mcpr.AddPaths(topInnerCP, ClipperLib.PolyType.ptSubject, true);
        mcpr.AddPaths(compassCP, ClipperLib.PolyType.ptClip, true);
        var msol = new ClipperLib.Paths();
        mcpr.Execute(ClipperLib.ClipType.ctDifference, msol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
        topInnerCP = msol;
      }

      // Merge title backer with frame
      if (titleResult && titleResult.backerCP && titleResult.backerCP.length) {
        var tcpr = new ClipperLib.Clipper();
        tcpr.AddPaths(topInnerCP, ClipperLib.PolyType.ptSubject, true);
        tcpr.AddPaths(titleResult.backerCP, ClipperLib.PolyType.ptClip, true);
        var tsol = new ClipperLib.Paths();
        tcpr.Execute(ClipperLib.ClipType.ctDifference, tsol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
        topInnerCP = tsol;
      }

      topPiece.cutD = pathsToD(topInnerCP);
    }

    // Compass + title letter engrave as raw SVG
    var rawSvg = '';
    rawSvg += compassSvgExport(wMm, hMm);
    if (titleResult && titleResult.engraveD) {
      // Title letter outlines only — NOT the backer blob
      rawSvg += '<path d="' + titleResult.engraveD + '" fill="#000000" fill-rule="evenodd"/>\n';
    } else {
      rawSvg += titleSvgExport(wMm, hMm);
    }
    if (rawSvg) topPiece.rawSvg = rawSvg;
    pieces.push(topPiece);


    // ── Assemble SVG — side by side ──
    var pad = 5;
    var gap = 10;
    var labelH = 14;
    var totalPieces = pieces.length;
    var svgW = totalPieces * wMm + (totalPieces - 1) * gap + pad * 2;
    var svgH = hMm + pad * 2 + labelH;

    var svg = [];
    svg.push('<?xml version="1.0" encoding="UTF-8"?>');
    svg.push('<!-- Topo Map — RED=#FF0000 CUT  BLUE=#0000FF SCORE  BLACK=#000000 ENGRAVE -->');
    svg.push('<svg xmlns="http://www.w3.org/2000/svg" width="' + svgW.toFixed(2) + 'mm" height="' + svgH.toFixed(2) + 'mm" viewBox="' + (-pad) + ' ' + (-pad) + ' ' + svgW.toFixed(2) + ' ' + svgH.toFixed(2) + '">');

    for (var pi = 0; pi < pieces.length; pi++) {
      var piece = pieces[pi];
      var ox = pi * (wMm + gap);
      svg.push('<g id="' + piece.label.replace(/[^a-zA-Z0-9]/g,'_') + '" transform="translate(' + ox.toFixed(2) + ',0)">');
      svg.push('<text x="' + (wMm/2).toFixed(1) + '" y="' + (hMm + 5).toFixed(1) + '" text-anchor="middle" font-family="Arial,sans-serif" font-size="3" fill="#666">' + piece.label + '</text>');

      if (piece.rect) {
        svg.push('<rect x="0" y="0" width="' + wMm.toFixed(3) + '" height="' + hMm.toFixed(3) + '" rx="' + cornerMm.toFixed(2) + '" ry="' + cornerMm.toFixed(2) + '" fill="none" stroke="#FF0000" stroke-width="0.1"/>');
      }
      if (piece.cutD) {
        svg.push('<path d="' + piece.cutD + '" fill="none" stroke="#FF0000" stroke-width="0.1" fill-rule="evenodd"/>');
      }
      if (piece.cutD2) {
        svg.push(piece.cutD2);
      }
      if (piece.scoreD && piece.scoreD.trim()) {
        svg.push('<path d="' + piece.scoreD.trim() + '" fill="none" stroke="#0000FF" stroke-width="0.15" fill-rule="evenodd"/>');
      }

      if (piece.engraveD && piece.engraveD.trim()) {
        svg.push('<path d="' + piece.engraveD.trim() + '" fill="#000000" stroke="none" fill-rule="evenodd"/>');
      }
      if (piece.rawSvg) {
        svg.push(piece.rawSvg);
      }
      svg.push('</g>');
    }

    // Color guide legend — only show relevant colors per layer
    var gy = hMm + 5;
    svg.push('<g font-family="Arial,sans-serif" font-size="2.8">');
    for (var gi3 = 0; gi3 < pieces.length; gi3++) {
      var p = pieces[gi3];
      var hasCut = p.rect || (p.cutD && p.cutD.trim());
      var hasScore = p.scoreD && p.scoreD.trim();
      var hasEngrave = (p.engraveD && p.engraveD.trim()) || p.rawSvg;
      // Skip guide entirely if only cuts (base layer etc.)
      if (!hasScore && !hasEngrave) continue;
      var gx2 = gi3 * (wMm + gap);
      var parts = [];
      if (hasCut) parts.push('<tspan fill="#FF0000">\u25a0</tspan> CUT');
      if (hasScore) parts.push('<tspan fill="#0000FF">\u25a0</tspan> SCORE');
      if (hasEngrave) parts.push('<tspan fill="#000000">\u25a0</tspan> ENGRAVE');
      svg.push('<text x="' + (gx2 + wMm/2).toFixed(1) + '" y="' + (gy + 3).toFixed(1) + '" text-anchor="middle" fill="#888">');
      svg.push(parts.join('  '));
      svg.push('</text>');
    }
    svg.push('</g>');

    svg.push('</svg>');
    var blob = new Blob([svg.join('\n')], { type: 'image/svg+xml' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'map-plaque.svg';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(a.href);
    trackEvent('TopoMap_downloaded');

  } catch(err) {
    console.error('Export error:', err);
    alert('Export failed: ' + err.message);
  } finally {
    dlBtn.disabled = false;
    dlBtn.textContent = '↓ Download SVG';
  }
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  EVENT SETUP                                                 ║
   ╚════════════════════════════════════════════════════════════════╝ */

function setupEvents() {
  // Address enter key
  $('addressInput').addEventListener('keydown', function(e) { if (e.key === 'Enter') searchAddress(); });

  // Zoom slider
  $('zoomSlider').addEventListener('input', function() {
    S.zoom = parseFloat(this.value);
    $('zoomVal').textContent = S.zoom;
    if (S.map) S.map.setZoom(S.zoom);
  });

  // GPX route width slider
  $('gpxWidthSlider').addEventListener('input', function() {
    S.gpxRouteWidth = parseFloat(this.value);
    $('gpxWidthVal').textContent = S.gpxRouteWidth.toFixed(1) + ' mm';
  });

  // Segment controls
  initSeg('detailSeg', function(v) { setDetail(v); if (!fastRedrawOverlays()) redrawPreview(); });
  initSeg('roadsSeg', function(v) { toggleRoads(v === 'on'); });
  initSeg('labelsSeg', function(v) { toggleLabels(v === 'on'); });
  // Depth layer buttons (custom layout, not standard seg)
  ['depthBtn1','depthBtn2','depthBtn3','depthBtn4'].forEach(function(btnId) {
    $(btnId).addEventListener('click', function() {
      ['depthBtn1','depthBtn2','depthBtn3','depthBtn4'].forEach(function(id){ $(id).classList.remove('on'); });
      this.classList.add('on');
      setDepthLayers(this.dataset.v);
    });
  });


  initSeg('contourSeg', function(v) { S.contourLines = v==='on'; _terrainImageData=null; redrawPreview(); });

  initSeg('compassSeg', function(v) { S.compassCorner = v; redrawPreview(); });
  initSeg('compassMergeSeg', function(v) { S.compassMerge = v==='on'; redrawPreview(); });
  initSeg('unitSeg', function(v) { switchUnit(v); });

  // Title d-pad: hold to repeat
  var dpadTimer = null;
  $('titleDpad').querySelectorAll('[data-dx]').forEach(function(btn) {
    var fire = function() {
      nudgeTitle(parseInt(btn.dataset.dx), parseInt(btn.dataset.dy));
    };
    btn.addEventListener('mousedown', function(e) {
      e.preventDefault();
      fire();
      dpadTimer = setInterval(fire, 100);
    });
    btn.addEventListener('mouseup', function() { clearInterval(dpadTimer); });
    btn.addEventListener('mouseleave', function() { clearInterval(dpadTimer); });
    btn.addEventListener('touchstart', function(e) {
      e.preventDefault();
      fire();
      dpadTimer = setInterval(fire, 100);
    });
    btn.addEventListener('touchend', function() { clearInterval(dpadTimer); });
  });

  // Title input
  if ($('titleInput')) $('titleInput').addEventListener('input', function() { S.titleText = this.value; redrawPreview(); });

  // Resize handler
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updatePreview, 100);
  });
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  INIT                                                        ║
   ╚════════════════════════════════════════════════════════════════╝ */

function init() {
  setupEvents();
  updateDimHint();

  // Set container dimensions FIRST so the map has real pixel space
  updatePreview();

  // Wait for MapLibre to be available, then create the map
  function bootMap() {
    if (typeof maplibregl === 'undefined') {
      setTimeout(bootMap, 100);
      return;
    }

    // Ensure containers have dimensions before creating map
    updatePreview();

    try {
      initMap();
    } catch(e) {
      console.error('Map init failed:', e);
      return;
    }

    // Aggressive resize schedule — MapLibre needs the canvas to
    // match the container AFTER tiles start arriving
    function forceResize() {
      if (!S.map) return;
      try {
        updatePreview();
        S.map.resize();
      } catch(e) { /* swallow */ }
    }

    S.map.on('load', forceResize);
    S.map.once('idle', forceResize);
    S.map.on('error', function(e) { console.warn('Map error:', e.error); });

    // Belt-and-suspenders: resize at several delays
    [100, 300, 600, 1500].forEach(function(ms) {
      setTimeout(forceResize, ms);
    });
  }

  // If DOM is ready but layout hasn't happened, wait a frame
  requestAnimationFrame(function() {
    updatePreview();
    bootMap();
  });
}

// Expose functions to global scope for HTML onclick attributes
window.adjDim = adjDim;
window.searchAddress = searchAddress;
window.downloadSVG = downloadSVG;
window.resetAll = resetAll;
window.handleGPX = handleGPX;
window.clearGPX = clearGPX;
window.toggleRoads = toggleRoads;
window.setDepthLayers = setDepthLayers;
window.generateLayers = generateLayers;
window.adjCov = adjCov;
window.adjContourDensity = adjContourDensity;
window.adjRoadThick = adjRoadThick;
window.adjLabelSz = adjLabelSz;
window.adjFrame = adjFrame;
window.adjCompassSz = adjCompassSz;
window.adjTitleSz = adjTitleSz;
window.setTitleFont = setTitleFont;
window.nudgeTitle = nudgeTitle;
window.backToMap = backToMap;
window.redrawPreview = redrawPreview;
window.trackEvent = trackEvent;

init();

});